function _esc(v) { v = (v == null ? '' : String(v)); return (window.CSS && CSS.escape) ? CSS.escape(v) : v; }
function _ready(fn) { if (document.readyState !== 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
function _slHide(sel) { document.querySelectorAll(sel).forEach(function (el) { el.style.display = 'none'; }); }
function _slShow(sel) { document.querySelectorAll(sel).forEach(function (el) { el.style.display = ''; }); }
function _el(elOrSel) { return typeof elOrSel === 'string' ? document.querySelector(elOrSel) : elOrSel; }
function _slideDown(sel) {
    var el = _el(sel);
    if (!el) return;
    el.style.removeProperty('display');
    if (getComputedStyle(el).display === 'none') el.style.display = 'block';
    var h = el.offsetHeight;
    el.style.overflow = 'hidden';
    el.style.height = '0px';
    el.style.transition = 'height 300ms ease';
    requestAnimationFrame(function () { el.style.height = h + 'px'; });
    setTimeout(function () { ['height', 'overflow', 'transition'].forEach(function (p) { el.style.removeProperty(p); }); }, 320);
}
function _slideUp(sel) {
    var el = _el(sel);
    if (!el) return;
    el.style.overflow = 'hidden';
    el.style.height = el.offsetHeight + 'px';
    el.style.transition = 'height 300ms ease';
    requestAnimationFrame(function () { el.style.height = '0px'; });
    setTimeout(function () { el.style.display = 'none'; ['height', 'overflow', 'transition'].forEach(function (p) { el.style.removeProperty(p); }); }, 320);
}
function _slideToggle(sel) {
    var el = _el(sel);
    if (!el) return;
    getComputedStyle(el).display === 'none' ? _slideDown(el) : _slideUp(el);
}
function _clickSel(sel) { var el = document.querySelector(sel); if (el) el.click(); }
function _fromHTML(html) { var t = document.createElement('template'); t.innerHTML = html.trim(); return t.content.firstElementChild; }
function _visible(el) { return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }
function _setName(sel, val) { var e = document.querySelector(sel); if (e) e.setAttribute('name', val); }
function _setText(sel, val) { var e = document.querySelector(sel); if (e) e.textContent = val; }
function _syncMainPriceDel() {
    var bundleOpts = document.querySelector('.subscription_inner.bundles-product-main .option-values');
    if (bundleOpts) {
        var checked = bundleOpts.querySelector('input[type="radio"]:checked');
        var com_val = checked ? checked.getAttribute('data-compare-price') : '';
        document.querySelectorAll('.price.main_price del').forEach(function (d) { d.textContent = com_val; });
    }
    var singleActive = document.querySelector('.subscription_inner.has_single_subscription_inner .pack_list-value.active_pack');
    if (singleActive) {
        var del = singleActive.querySelector('del');
        document.querySelectorAll('.price.main_price del').forEach(function (d) { d.textContent = del ? del.textContent : ''; });
    }
}
function _rcSelect(val) { var rc = document.querySelector('#rc_duplicate_selector'); if (!rc) return; rc.value = val; rc.dispatchEvent(new Event('change', { bubbles: true })); }
function _rcSelectIn(scope, val) { var rc = scope && scope.querySelector('#rc_duplicate_selector'); if (!rc) return; rc.value = val; rc.dispatchEvent(new Event('change', { bubbles: true })); }
function _stickyBtn(btnSel, wrapSel) {
    var btns = document.querySelectorAll(btnSel);
    if (!btns.length || !document.querySelector(wrapSel)) return;
    var window_height = window.pageYOffset + 30;
    btns.forEach(function (btn) {
        var wrap = btn.closest(wrapSel);
        if (!wrap) return;
        wrap.classList.remove('sticky-btn');
        var fixmeTop = wrap.getBoundingClientRect().top + window.pageYOffset;
        if (window_height >= fixmeTop) wrap.classList.add('sticky-btn');
    });
}
function _fadeIn(sel) { var el = _el(sel); if (!el) return; el.style.opacity = '0'; el.style.removeProperty('display'); if (getComputedStyle(el).display === 'none') el.style.display = 'block'; el.style.transition = 'opacity 300ms ease'; requestAnimationFrame(function () { el.style.opacity = '1'; }); setTimeout(function () { ['opacity', 'transition'].forEach(function (p) { el.style.removeProperty(p); }); }, 320); }

function variant_Desc(cur_varaint) {
    var activeGallery = cur_varaint
        ? document.querySelector('.pdp_gallery_wpr.variant_' + _esc(cur_varaint))
        : null;

    if (activeGallery) {
        _slHide('.pdp_gallery_wpr');
        _slShow('.pdp_gallery_wpr.variant_' + _esc(cur_varaint));
    } else {
        _slShow('.pdp_gallery_wpr');
    }

    setTimeout(function () {
        var configs = [
            { slider: '.pdp_gallery_slider1', thumbs: '.pdp_gallery_thumbs1', sarrow: '.gallery-slider_arrow1', tarrow: '.gallery-thumbs_arrow1', pag: '.pdp_gallery_pagition1' },
            { slider: '.pdp_gallery_slider2', thumbs: '.pdp_gallery_thumbs2', sarrow: '.gallery-slider_arrow2', tarrow: '.gallery-thumbs_arrow2', pag: '.pdp_gallery_pagition2' },
            { slider: '.pdp_gallery_slider3', thumbs: '.pdp_gallery_thumbs3', sarrow: '.gallery-slider_arrow3', tarrow: '.gallery-thumbs_arrow3', pag: '.pdp_gallery_pagition3' },
            { slider: '.pdp_gallery_slider4', thumbs: '.pdp_gallery_thumbs4', sarrow: '.gallery-slider_arrow4', tarrow: '.gallery-thumbs_arrow4', pag: '.pdp_gallery_pagition4' },
            { slider: '.pdp_gallery_slider5', thumbs: '.pdp_gallery_thumbs5', sarrow: '.gallery-slider_arrow5', tarrow: '.gallery-thumbs_arrow5', pag: '.pdp_gallery_pagition5' }
        ];
        configs.forEach(function (c) {
            var sliderEl = document.querySelector(c.slider);
            var thumbsEl = document.querySelector(c.thumbs);
            if (!sliderEl) return;
            if (sliderEl.swiper) {
                sliderEl.swiper.update();
                if (thumbsEl && thumbsEl.swiper) thumbsEl.swiper.update();
                return;
            }
            var wpr = sliderEl.closest('.pdp_gallery_wpr');
            if (wpr && wpr.offsetParent !== null) {
                var P_thumbs = thumbsEl ? new Swiper(c.thumbs, {
                    slidesPerView: 5, spaceBetween: 6, watchSlidesVisibility: true,
                    navigation: { nextEl: '.swiper-button-next.' + c.tarrow.replace('.', ''), prevEl: '.swiper-button-prev.' + c.tarrow.replace('.', '') },
                    breakpoints: { 992: { slidesPerView: 5 }, 768: { slidesPerView: 4, centeredSlides: false } }
                }) : null;
                new Swiper(c.slider, {
                    slidesPerView: 1,
                    navigation: { nextEl: '.swiper-button-next.' + c.sarrow.replace('.', ''), prevEl: '.swiper-button-prev.' + c.sarrow.replace('.', '') },
                    pagination: { el: c.pag, type: 'bullets', clickable: 'true' },
                    thumbs: P_thumbs ? { swiper: P_thumbs } : undefined
                });
            }
        });
    }, 100);

    var _checked = document.querySelector('.pdp_pack_list .pdp_pack_input:checked');
    var cur_var = _esc(_checked ? _checked.getAttribute('data-var') : '');
    _slHide('.pdp_description_inner');
    _slHide('.sub_title');
    if (cur_var && document.querySelector('.sub_title.' + cur_var)) {
        _slShow('.sub_title.' + cur_var);
    } else {
        _slShow('.sub_title.default_title');
    }
    if (document.querySelector('ul.left_top_content.collapsible-panels.variant_' + cur_var)) {
        _slHide('ul.collapsible-panels.left_top_content');
        _slShow('.pdp_description_inner.variant_' + cur_var);
        _slShow('ul.collapsible-panels.left_top_content.variant_' + cur_var);
    } else {
        _slShow('.pdp_description_inner.default_product');
        _slHide('ul.collapsible-panels.left_top_content');
        _slShow('ul.collapsible-panels.left_top_content.default_description_product');
    }
    if (document.querySelector('ul.left_top_content_bottom.collapsible-panels.variant_' + cur_var)) {
        _slHide('ul.collapsible-panels.left_top_content_bottom');
        _slShow('ul.collapsible-panels.left_top_content_bottom.variant_' + cur_var);
    } else {
        _slHide('ul.collapsible-panels.left_top_content_bottom');
        _slShow('ul.collapsible-panels.left_top_content_bottom.default_product');
    }
}


_ready(function () {
    function ratingHTML() {
        const elements = document.querySelectorAll('.ruk-rating-snippet-count');

        if (elements.length > 0) {
            elements.forEach(function(element) {
                element.innerHTML = element.innerHTML.replace("(", "").replace(")", "");
            });
        } else {
            setTimeout(function() {
                ratingHTML();
            }, 500);
        }
    }

    ratingHTML();


    var cur_u = window.location.href;
    if (cur_u.indexOf('variant=') > -1) {
        var number = cur_u.split('variant=');
        var _pi = document.querySelector('.pdp_pack_input[value="' + number[1] + '"]');
        if (_pi) {
            _pi.click();
            var _pc = _pi.closest('.pdp_pack_col');
            if (_pc) _pc.classList.add('active');
        }
        var _ps = document.querySelector('.product-select');
        if (_ps) _ps.value = number[1];
    }

    var _chkPack = document.querySelector('.pdp_pack_option_input:checked');
    var _packCol = _chkPack ? _chkPack.closest('.pdp_pack_option_col') : null;
    var _cartWpr = document.querySelector('.add_cart_wpr');
    function _packAttr(a) { return _packCol ? _packCol.getAttribute(a) : (_cartWpr ? _cartWpr.getAttribute(a) : null); }
    function _btnPrice(t) { var s = document.querySelector('.add_to_cart_btn span'); if (s) s.textContent = t; }
    function _setHtml(sel, html) { var el = document.querySelector(sel); if (el) el.innerHTML = html; }

    var _chkVar = document.querySelector('.pdp_pack_list .pdp_pack_input:checked');
    variant_Desc(_chkVar ? _chkVar.getAttribute('data-var') : undefined);
    var cur_pack_price = _packAttr('data-pack-dis-price');
    var data_pack_price = _packAttr('data-pack-price');
    var dat_pack_sprice = _packAttr('data-pack-dis-price-s');
    var data_sub_price_load = _packAttr('data-sub-price');

    if (cur_pack_price != '') {
        _setHtml('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_price', '<span class="del_price">' + data_pack_price + '</span><span class="price">' + cur_pack_price + '</span>');
        _btnPrice(cur_pack_price);
    } else if (dat_pack_sprice) {
        _setHtml('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_price', '<span class="del_price">' + data_pack_price + '</span><span class="price">' + dat_pack_sprice + '</span>');
        _btnPrice(dat_pack_sprice);
    } else {
        _setHtml('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_price', '<span class="price">' + data_pack_price + '</span>');
        _setHtml('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save .price_main', '<span class="del_price">' + data_pack_price + '</span><span class="price">' + data_sub_price_load + '</span>');
        _btnPrice(data_pack_price);
    }

    var _btn = document.querySelector('.add_to_cart_btn');
    var _subRadio = document.querySelector('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save .pdp_drop_radio');
    var _buyOnceRadio = document.querySelector('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_radio');

    if (_chkPack && parseInt(_chkPack.value) == 1) {
        document.querySelectorAll('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save').forEach(function (el) { el.classList.remove('unavailable_subscribe'); });
        var _availableSubRadio = document.querySelector('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save:not(.hideVariant_ubscription):not(.unavailable_subscribe) .pdp_drop_radio');
        if (_availableSubRadio) {
            // The subscription option is already rendered server-side; do not trigger a synthetic change or opening animation on page load.
            _availableSubRadio.checked = true;
            if (_btn) _btn.classList.add('has_subscription');
        } else {
            if (_buyOnceRadio) _buyOnceRadio.checked = true;
            if (_btn) _btn.classList.remove('has_subscription');
        }
    } else {
        document.querySelectorAll('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save').forEach(function (el) { el.classList.add('unavailable_subscribe'); });
        if (_buyOnceRadio) _buyOnceRadio.checked = true;
        if (_btn) _btn.classList.remove('has_subscription');
    }

    if (_subRadio && _subRadio.checked) {
        _btnPrice(_packAttr('data-sub-price'));
    }

    if (document.querySelectorAll('.pdp_pack_list .pdp_pack_col').length == 1) {
        var _pl = document.querySelector('.pdp_pack_list');
        if (_pl) _pl.classList.add('pdp_pack_list_single');
    }


    document.addEventListener('change', function (e) {
        var t = e.target.closest('.pdp_pack_option_wpr .pdp_pack_option_input');
        if (!t) return;
        var col = t.closest('.pdp_pack_option_col');
        var mprice = col ? col.getAttribute('data-pack-price') : null;
        var cprice = col ? col.getAttribute('data-pack-dis-price') : null;
        var sprice = col ? col.getAttribute('data-pack-dis-price-s') : null;
        var cprices = parseFloat((cprice || '').replace('$', ''));
        var sprice_s = parseFloat((sprice || '').replace('$', ''));
        var data_sub_price = col ? col.getAttribute('data-sub-price') : null;

        if (cprice) {
            _setHtml('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_price', '<span class="del_price">' + mprice + '</span><span class="price">' + cprice + '</span>');
            _btnPrice(cprice);
        } else if (sprice) {
            _setHtml('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_price', '<span class="del_price">' + mprice + '</span><span class="price">' + sprice + '</span>');
            _btnPrice(sprice);
        } else {
            _setHtml('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_price', '<span class="price">' + mprice + '</span>');
            _setHtml('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save .price_main', '<span class="del_price">' + mprice + '</span><span class="price">' + data_sub_price + '</span>');
            _btnPrice(mprice);
        }

        var _wpr = document.querySelector('.pdp_pack_option_wpr');
        var data_t = parseFloat(_wpr ? _wpr.getAttribute('data-thresh') : '');

        var cprices_d, g_price, p_g_price;
        if (cprices) {
            cprices_d = cprices; g_price = cprices; p_g_price = cprices;
        } else if (sprice_s) {
            cprices_d = sprice_s; g_price = sprice_s; p_g_price = sprice_s;
        } else {
            cprices_d = parseFloat((mprice || '').replace('$', ''));
            data_sub_price = parseFloat((data_sub_price || '').replace('$', ''));
            g_price = data_sub_price; p_g_price = cprices_d;
        }

        var _fs = col ? col.querySelector('.pdp_pack_option_value .pack_free_shipping') : null;
        if (_fs) _fs.style.display = (cprices_d > data_t) ? '' : 'none';

        var _gc = col ? col.querySelector('.gummies_count') : null;
        var gummies = _gc ? _gc.getAttribute('data-gummies') : null;
        var _btn2 = document.querySelector('.add_to_cart_btn');
        if (parseInt(t.value) == 1) {
            document.querySelectorAll('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save').forEach(function (el) { el.classList.remove('unavailable_subscribe'); });
            if (document.querySelector('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save:not(.hideVariant_ubscription):not(.unavailable_subscribe) .pdp_drop_radio')) {
                _clickSel('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save .pdp_drop_radio');
                _slideDown('.pdp_drop_info');
            } else {
                _clickSel('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_radio');
            }
            if (_btn2) _btn2.classList.add('has_subscription');
        } else {
            document.querySelectorAll('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save').forEach(function (el) { el.classList.add('unavailable_subscribe'); });
            _clickSel('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_radio');
            if (_btn2) _btn2.classList.remove('has_subscription');
        }
        if (_gc) _gc.textContent = '$' + (parseFloat(g_price) / gummies).toFixed(2) + ' / Gummy';
        var _form = t.closest('form');
        var _buyGc = _form ? _form.querySelector('.pdp_drop_slide_wpr.buy_once .gummies_count') : null;
        if (_buyGc) _buyGc.textContent = '$' + (parseFloat(p_g_price) / gummies).toFixed(2) + ' / Gummy';
    });




    document.addEventListener('change', function (e) {
        var t = e.target.closest('.pdp_drop_main .pdp_drop_radio');
        if (!t) return;
        var chk = document.querySelector('.pdp_pack_option_input:checked');
        var chkCol = chk ? chk.closest('.pdp_pack_option_col') : null;
        var gcEl = chkCol ? chkCol.querySelector('.gummies_count') : null;
        var gummies = gcEl ? gcEl.getAttribute('data-gummies') : null;
        var slide = t.closest('.pdp_drop_slide_wpr');
        var priceEl = slide ? slide.querySelector('.pdp_drop_price .price') : null;
        var cur_price = priceEl ? priceEl.textContent : '';
        var isBuyOnce = slide && slide.classList.contains('buy_once');
        var btn = document.querySelector('.add_to_cart_btn');
        if (btn) {
            btn.classList[isBuyOnce ? 'remove' : 'add']('has_subscription');
            var span = btn.querySelector('span');
            if (span) span.textContent = cur_price;
        }
        if (gcEl) gcEl.textContent = '$' + (parseFloat(cur_price.replace('$', '')) / gummies).toFixed(2) + ' / Gummy';
        if (isBuyOnce) _slideDown('.pdp_pack_option_wpr'); else _slideUp('.pdp_pack_option_wpr');
    });

    document.addEventListener('click', function (e) {
        var btn = e.target.closest('button.pdp_primary.add_to_cart_btn');
        if (!btn) return;
        e.preventDefault();
        var form = btn.closest('form');
        if (!form) return;
        var fd = new FormData(form);
        if (btn.classList.contains('has_subscription')) {
            var sp = form.querySelector('[name=selling_plan_id]');
            fd.append('selling_plan', sp ? sp.value : '');
        }
        fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function () {
                if (window.cartMini) {
                    window.cartMini.refresh();
                    setTimeout(function () { window.cartMini.open(); }, 100);
                }
            })
            .catch(function () {});
    });


    /* ----- new pdp js end ----- */


    if (document.querySelectorAll('.template-product .option-values .option-value').length == 1) {
        document.querySelectorAll('.template-product .option-values .option-value').forEach(function (x) { x.classList.add('has_single_option'); });
        document.querySelectorAll('.template-product .option-values').forEach(function (x) { x.classList.add('has_single_option_main'); });
        document.querySelectorAll('.template-product .option-header').forEach(function (x) { x.classList.add('has_single_option_header'); });
        document.querySelectorAll('.template-product .subscription_inner').forEach(function (x) { x.classList.add('has_single_subscription_inner'); });
    }
});

if (document.querySelector('#graph-section')) {

    function $$(selector, context) {
        context = context || document;
        var elements = context.querySelectorAll(selector);
        return Array.prototype.slice.call(elements);
    }

    function show_chart() {
        $$('.stat--productivity .pie').forEach(function(pie) {
            var percents = pie.textContent.split(",");
            percents = percents.map(function(pct, idx) {
                return {
                    value: parseFloat(pct),
                    sum: 0,
                    idx: idx + 1
                }
            });
            for (var i = 0; i < percents.length; i++) {
                var prevSum = (i > 0) ? percents[i - 1].sum : 1;
                percents[i].sum = prevSum + percents[i].value;
            };
            percents.reverse();
            var NS = "http://www.w3.org/2000/svg";
            var svg = document.createElementNS(NS, "svg");
            pie.textContent = ''; //clear div
            svg.setAttribute("viewBox", "0 0 32 32");
            pie.appendChild(svg);
            percents.forEach(function(pct, idx) {
                var circle = document.createElementNS(NS, "circle");
                circle.classList.add("circle" + pct.idx);
                circle.setAttribute("r", 16);
                circle.setAttribute("cx", 16);
                circle.setAttribute("cy", 16);
                circle.setAttribute("stroke-dasharray", "0 100");
                setTimeout(function() {
                    circle.setAttribute("stroke-dasharray", pct.sum + " 100");
                });
                svg.appendChild(circle);
            });
            percents.forEach(function(pct, idx) {
                var digit = document.createElement("span");
                digit.textContent = pct.value + " %";
                digit.classList.add("label" + (idx + 1));
                pie.appendChild(digit);
            });
        });
    }
    //------------------------///


    show_chart();
    function _onGraphScroll() {
        $$('#graph-section').forEach(function (el) {
            el.classList.remove('active');
            var docViewTop = window.pageYOffset;
            var docViewBottom = docViewTop + 20 + window.innerHeight;
            var elemTop = el.getBoundingClientRect().top + docViewTop;
            var elemBottom = elemTop - el.offsetHeight;
            if (elemTop > docViewTop && elemBottom < docViewBottom) {
                if (!el.classList.contains('show')) {
                    el.classList.add('show');
                    show_chart();
                }
            } else {
                el.classList.remove('show');
            }
        });
    }
    window.addEventListener('load', _onGraphScroll);
    window.addEventListener('scroll', _onGraphScroll);

}
/*----------popup----------*/
window.popup = (function() {
    function Popup(args) {
        if (typeof args !== 'undefined') {
            //if 'click to open' selector is undefined, return with the info in console
            if (typeof args.clickToOpen === 'undefined') {
                // console.log('"clickToOpen" param is not defined.'); 
                return;
            }

            //if the element coresponds to 'clickToOpen' selector is undefined, return with info in console
            if (!document.querySelector(args.clickToOpen)) {
                // console.log('The element associated with "clickToOpen" param is not defined.'); 
                return;
            }

            //if 'click to open' selector is defined but 'data-trigger-popup' is undefined, return with the info in console.
            if (typeof document.querySelector(args.clickToOpen).dataset.triggerPopup === 'undefined' || document.querySelector(args.clickToOpen).dataset.triggerPopup == '') {
                // console.log('"data-trigger-popup" attribute of "clickToOpen" selector is not properly defined.');
                return;
            }

            //set argument params
            args.container = document.querySelector(args.clickToOpen).dataset.triggerPopup;
            args.clickToClose = (typeof args.clickToClose !== 'undefined') ? args.clickToClose : '.popup-close';
            args.setCookieToHide = (typeof args.setCookieToHide === 'boolean') ? args.setCookieToHide : false;
            args.delay = (typeof args.delay === 'number' && args.delay > 0) ? args.delay : false;
        } else {
            //if no arg params present, return with info in console
            // console.log('Both "clickToOpen" selector and its "data-trigger-popup" attribute have to be properly defined'); 
            return;
        }
        //config params
        this.args = args;
        //init popup
        this.init();
    }
    Popup.prototype.init = function() {
        var $container = document.querySelector(this.args.container);
        var _this = this;
        //if container element is not defined, return with info in console
        if (!$container) {
            // console.log('container element is not defined'); 
            return;
        }
        this.$container = $container;
        //trigger popup on click.
        document.querySelector(this.args.clickToOpen).addEventListener('click', function(e) {
            e.preventDefault();
            //close mobile menu
            if (this.classList.contains('mobile')) {
                document.querySelector('.mobile-dropdown--close').click();
            }
            //call 'open' function
            _this.open();
        });
        //get the elements to close popup
        var $clickToCloseElements = this.$container.querySelectorAll(this.args.clickToClose);
        for (var i = 0; i < $clickToCloseElements.length; i++) {
            //close popup on click
            $clickToCloseElements[i].addEventListener('click', function(e) {
                e.preventDefault();
                _this.close();
            });
        }
        //close popup when someone clicks on overlay
        this.$container.querySelector('.popup-overlay') && this.$container.querySelector('.popup-overlay').addEventListener('click', function() {
            _this.close();
        });
        //check if cookie is used to show/hide the popup
        if (this.args.setCookieToHide) {
            var popupCookieName = (typeof this.$container.dataset.cookieName !== 'undefined' || this.$container.dataset.cookieName == '') ? this.$container.dataset.cookieName : 'popup' + this.args.clickToOpen;
            var popupCookieInterval = (typeof this.$container.dataset.cookieInterval !== 'undefined' || this.$container.dataset.cookieInterval == '') ? parseInt(this.$container.dataset.cookieInterval) : 7;
            //set current cookie name and interval
            this.cookieName = popupCookieName;
            this.cookieInterval = popupCookieInterval;
            var currentCookieVal = this.getCookie(popupCookieName);
            if (currentCookieVal == false) {
                setTimeout(function() {
                    document.querySelector(_this.args.clickToOpen).click();
                }, 100);
            }
        }
    };
    Popup.prototype.open = function() {
        //if cookie is used to show/hide popup, clear the cookie before openning

        this.previousFocusedElement = document.activeElement;

        if (this.args.setCookieToHide && this.cookieName) {
            this.setCookie(this.cookieName, '', -1);
        }
        //Entire popup layout is css controlled so all we need to do is add the class 'popup-active'
        if (this.args.delay) {
            var _this = this;
            setTimeout(function() {
                _this.$container.classList.add('popup-active');
            }, _this.args.delay);
        } else {
            this.$container.classList.add('popup-active');
            this.$container.setAttribute('aria-hidden', 'false');
            this.$container.focus();
        }

        var _this = this; // Capture the context
        document.addEventListener('keydown', function handleEscapeKey(event) {
            if (event.key === 'Escape' || event.keyCode === 27) {
                if (_this.$container.classList.contains('popup-active')) {
                    _this.close();
                }
            }
        });
    };
    Popup.prototype.close = function() {
        //Entire popup layout is css controlled so all we need to do is remove the class 'popup-active'
        this.$container.classList.remove('popup-active');
        this.$container.setAttribute('aria-hidden', 'true');

        if (this.previousFocusedElement) {
            this.previousFocusedElement.focus();
        }

        //if cookie is used to show/hide popup, set cookie once user closes the popup
        if (this.args.setCookieToHide && this.cookieName && this.cookieInterval) {
            this.setCookie(this.cookieName, 'disabled', this.cookieInterval);
        }
        //console.log(this.getCookie(this.cookieName));
    };
    Popup.prototype.setCookie = function(cookieName, cookieVal, cookieInterval) {
        var date = new Date();
        date.setTime(date.getTime() + (cookieInterval * 24 * 60 * 60 * 1000));
        var expires = "expires=" + date.toUTCString();
        document.cookie = cookieName + "=" + cookieVal + ";" + expires + ";SameSite=Lax;path=/";
    }
    Popup.prototype.getCookie = function(cookieName) {
        var cookieTermString = cookieName + "=";
        var cookieArray = document.cookie.split(';');
        for (var i = 0; i < cookieArray.length; i++) {
            var cookieItem = cookieArray[i];
            while (cookieItem.charAt(0) == ' ') {
                cookieItem = cookieItem.substring(1);
            }
            if (cookieItem.indexOf(cookieTermString) == 0) {
                return cookieItem.substring(cookieTermString.length, cookieItem.length);
            }
        }
        return false;
    }
    return Popup;
})();
/*----------Newsletter popup--------*/
new popup({
    clickToOpen: '.newsletter-popup-open',
    setCookieToHide: true,
    delay: 30000
});
new popup({
    clickToOpen: '[data-newsletter-popup-link]',
    setCookieToHide: false
});
new popup({
    clickToOpen: '[data-newsletter-popup-link-mobile]',
    setCookieToHide: false
});
/*--------Doctor profile popup---------*/
var $profilePopups = document.querySelectorAll('.profile-popup-open');
for (var i = 0; i < $profilePopups.length; i++) {
    var blockId = $profilePopups[i].dataset.blockId;
    var selector = '.profile-popup-open-' + blockId;
    new popup({
        clickToOpen: selector,
        setCookieToHide: false,
        onOpen: function() {
            var popupElement = document.querySelector(selector);

            if (popupElement) {
                popupElement.setAttribute('tabindex', '-1');
                popupElement.focus();
            }
        },
        onClose: function() {
            $profilePopups[i].focus();
        }
    });
}
/*------product grid item equal height-------*/
var equalizeCardDetailsHeight = function() {
    var $gridItems = document.querySelectorAll('.product-list');
    for (var i = 0; i < $gridItems.length; i++) {

        // Cache the highest
        var highestBox = 0;

        // Select and loop the elements you want to equalise
        var $detailsBoxitems = $gridItems[i].querySelectorAll('.product-card-details');
        for (var j = 0; j < $detailsBoxitems.length; j++) {
            //remove initial height set with style attribute 
            $detailsBoxitems[j].style.removeProperty("height");
            // If this box is higher than the cached highest then store it
            if ($detailsBoxitems[j].clientHeight > highestBox) {
                highestBox = $detailsBoxitems[j].clientHeight + 20;
            }

        }
        //console.log(highestBox);
        // Set the height of all those children to whichever was highest 
        for (var k = 0; k < $detailsBoxitems.length; k++) {
            $detailsBoxitems[k].style.height = highestBox + 'px';
        }
    }
}
equalizeCardDetailsHeight();
window.onresize = function() {
    equalizeCardDetailsHeight();
}
/*--------infinite scroll-------*/
window.infiniteScrollPagination = (function() {
    function InfiniteScrollPagination(args) {
        var args = args || {};
        args.paginationSelector = args.paginationSelector || '.ajax-pagination';
        args.container = args.container || '.ajax-grid-items';
        this.args = args;
        this.init();
    }
    InfiniteScrollPagination.prototype.init = function() {
        if (!document.querySelector(this.args.container) || !document.querySelector(this.args.paginationSelector)) return;
        var _this = this;
        window.addEventListener('scroll', function(e) {
            var $container = document.querySelector(_this.args.container);
            var $paginationEl = document.querySelector(_this.args.paginationSelector);
            if (!$paginationEl) return;
            var nextPageUrl = $paginationEl.getAttribute('href');
            var windowTop = window.pageYOffset || document.documentElement.scrollTop;
            var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            var windowBottom = windowTop + windowHeight;
            var containerBottom = $container.offsetTop + $container.clientHeight;
            if (windowBottom > containerBottom && !$paginationEl.classList.contains('loading')) {
                $paginationEl.classList.add('loading');
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", nextPageUrl, true);
                xhttp.responseType = "document";
                xhttp.send();
                xhttp.onreadystatechange = function() {
                    if (this.readyState == 4 && this.status == 200) {
                        var $resCont = this.response.querySelector(_this.args.container);
                        var $resPageEl = this.response.querySelector(_this.args.paginationSelector);
                        $container.innerHTML += $resCont.innerHTML;
                        if ($resPageEl) {
                            $paginationEl.parentNode.replaceChild($resPageEl, $paginationEl);
                        } else {
                            $paginationEl.parentNode.removeChild($paginationEl);
                        }
                        return false;
                    }
                };
            }
        });
    }
    return InfiniteScrollPagination;
})();
new infiniteScrollPagination();

function addToCartSuccess_free() {
    fetch('/cart?view=mini').then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('div[data-cart-mini-content]');
        var footer = doc.querySelector('div[data-cart-mini-footer]');
        var _c = document.querySelector('.cart-mini-content');
        var _f = document.querySelector('.cart-mini-footer');
        if (_c && content) _c.innerHTML = content.innerHTML;
        if (_f && footer) _f.innerHTML = footer.innerHTML;
    }).catch(function () {});
}
var $qtyChangeSelectors = document.querySelectorAll('span.qty-change');
for (var i = 0; i < $qtyChangeSelectors.length; i++) {
    $qtyChangeSelectors[i].addEventListener('click', function() {
        var $qtyInput = this.parentNode.querySelector('input[type="number"]');
        var qty = parseInt($qtyInput.value);
        var isInCart = $qtyInput.classList.contains('cart-item-quantity') ? true : false;
        if (this.classList.contains('qty-plus')) {
            qty += 1;
        } else if (this.classList.contains('qty-minus')) {
            if (isInCart) {
                qty = qty > 0 ? (qty - 1) : 0;
            } else {
                qty = qty > 1 ? (qty - 1) : 1;
            }
        }
        $qtyInput.value = qty;
        if (isInCart) {
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState == 4 && this.status == 200) {
                    if ($qtyInput.classList.contains('in-cart-template')) {
                        location.reload();
                    } else {
                        console.log('in cart modal');
                    }
                }
            };
            xhttp.open("POST", "/cart/change.js", true);
            xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            xhttp.send("quantity=" + qty + "&id=" + $qtyInput.dataset.itemKey);

        }
    });
}

/*------add class to mak header static in order to push announcement bar below------*/
function addStaticHeaderClass() {
    var windowTop = window.pageYOffset || document.documentElement.scrollTop;
    if (windowTop == 0) {
        if (document.querySelector('.new-header')) {
            document.querySelector('#shopify-section-alt-header').classList.add('header--static');
        } else {
            document.querySelector('#shopify-section-static-header').classList.add('header--static');
        }
        document.querySelector('.page-body-content').classList.add('no-top-margin');
    } else {
        if (document.querySelector('.new-header')) {
            document.querySelector('#shopify-section-alt-header').classList.remove('header--static');
        } else {
            document.querySelector('#shopify-section-static-header').classList.remove('header--static');
        }
        document.querySelector('.page-body-content').classList.remove('no-top-margin');
    }
}
window.onscroll = function() {
    addStaticHeaderClass();
};
addStaticHeaderClass();
/*-----Smooth scroll function------*/
// window.smoothScroll = (function(){
//   function SmoothScroll(args){
//     if(typeof args !== 'object'){
//       //if parameters are not defined return with info in console
//       console.log('parameters not definied.')
//       return;
//     } else {
//       //if destination not defined return with info in console
//       if(typeof args.destination === 'undefined'){
//         console.log('destination not defined'); 
//         return;
//       }
//       args.duration = (typeof args.duration === 'number') ? args.duration : 500;
//       args.callback = (typeof args.callback === 'function') ? args.callback : false;
//     }
//     this.args = args;
//     this.init();
//   }
//   SmoothScroll.prototype.init = function(){
//     var startPosition = window.pageYOffset;
//     var startTime = 'now' in window.performance ? performance.now() : new Date().getTime();
//     var documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight,document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
//     var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
//     var destinationOffset = typeof this.args.destination === 'number' ? this.args.destination : this.args.destination.offsetTop;
//     var destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);
// 	var duration = this.args.duration;
//     var callback = this.args.callback;
//     //in case of no 'requestAnimationFrame'
//     if ('requestAnimationFrame' in window === false) {
//       window.scroll(0, destinationOffsetToScroll);
//       //call the callback function
//       if (this.args.callback) {
//         this.args.callback();
//       }
//       return;
//     }

//     //scroll function for using 'requestAnimationFrame'
//     function scroll() {
//       var now = 'now' in window.performance ? performance.now() : new Date().getTime();
//       var time = Math.min(1, ((now - startTime) / duration));
//       window.scroll(0, Math.ceil((time * (destinationOffsetToScroll - startPosition)) + startPosition));

//       if (window.pageYOffset >= (destinationOffsetToScroll - 10)) {
//         //console.log('scroll end');
//         //call the callback function
//         if (callback) {
//           callback();
//         }
//         return;
//       } else {
//         requestAnimationFrame(scroll);
//       }
//     }
//     scroll();
//   }

//   return SmoothScroll;
// })();
/*-----Glossary page smooth scroll-----*/
var $chSelector = document.querySelectorAll('.characters a');
for (var i = 0; i < $chSelector.length; i++) {
    $chSelector[i].addEventListener('click', function(e) {
        e.preventDefault();
        var $scrollToSelector = document.querySelector(this.getAttribute('href'));
        var elemOffsetTop = $scrollToSelector.offsetTop;
        if (document.querySelector('.main-header--minimal-sticky')) {
            elemOffsetTop -= document.querySelector('.main-header--minimal-sticky').clientHeight;
        }
        //     window.scrollTo({
        //       'behavior': 'smooth',
        //       'left': 0,
        //       'top': elemOffsettop
        //     });
        window.scrollTo({ top: elemOffsetTop, behavior: "smooth" });

    });
}
// Function to scroll to the specified section
function scrollToSection() {
    var $scrollToSelector_find = document.querySelector('#shopify-section-logo_marquee_HXHmzK, #shopify-section-template--18408319025303__logo_marquee_HXHmzK');
    if ($scrollToSelector_find) {
        var elemOffsetTop_find = $scrollToSelector_find.offsetTop;
        var stickyHeader = document.querySelector('.main-header--minimal-sticky');

        if (stickyHeader) {
            elemOffsetTop_find -= stickyHeader.clientHeight;
        }
        window.scrollTo({ top: elemOffsetTop_find, behavior: "smooth" });
    }
}

// Check if the URL contains the specified hash and scroll to the section if it does
if (window.location.hash === "#shopify-section-logo_marquee_HXHmzK" || window.location.hash === "#shopify-section-template--18408319025303__logo_marquee_HXHmzK") {
    console.log('innn')
    scrollToSection();
}

// Add click event listener to the specific link
var $chSelector_find = document.querySelector('.cm_menu_col a[data-link="find-us"]');
if ($chSelector_find) {
    $chSelector_find.addEventListener('click', function(e) {
        scrollToSection();
    });
}


function scrollToSection_mobile() {
    var $scrollToSelector_find = document.querySelector('#shopify-section-logo_marquee_HXHmzK, #shopify-section-template--18408319025303__logo_marquee_HXHmzK');
    if ($scrollToSelector_find) {
        var elemOffsetTop_find = $scrollToSelector_find.offsetTop;
        var stickyHeader = document.querySelector('.main-header--minimal-sticky');

        if (stickyHeader) {
            elemOffsetTop_find -= stickyHeader.clientHeight;
        }
        document.querySelectorAll('.close-menu').forEach(function(el){el.click();});
        window.scrollTo({ top: elemOffsetTop_find, behavior: "smooth" });
    }
}

// Check if the URL contains the specified hash and scroll to the section if it does
if (window.location.hash === "#shopify-section-logo_marquee_HXHmzK") {
    console.log('innn')
    scrollToSection_mobile();
}

// Add click event listener to the specific link
var $chSelector_find_m = document.querySelector('.menu-links a[data-link="find-us"]');
if ($chSelector_find_m) {
    $chSelector_find_m.addEventListener('click', function(e) {
        scrollToSection_mobile();
    });
}


/*------Contact page tab-----*/
var $tabHeadings = document.querySelectorAll('.tabs input');
for (var i = 0; i < $tabHeadings.length; i++) {
    $tabHeadings[i].addEventListener('click', function(e) {
        e.preventDefault();
        if (this.parentNode.classList.contains('active')) {
            return;
        } else {
            this.parentNode.classList.add('active');
            document.querySelector(this.getAttribute('data-href')).classList.add('active');
            for (var j = 0; j < $tabHeadings.length; j++) {
                if (this != $tabHeadings[j]) {
                    $tabHeadings[j].parentNode.classList.remove('active');
                    document.querySelector($tabHeadings[j].getAttribute('data-href')).classList.remove('active');
                }
            }
        }
    });
}
//check if location hash contains tab name and trigger that tab
if (window.location.hash) {
    if (document.querySelector(window.location.hash) && document.querySelector('a[href="' + window.location.hash + '"]') && document.querySelector('a[href="' + window.location.hash + '"]').parentNode.classList.contains('tab-heading')) {
        var $elem = document.querySelector('a[href="' + window.location.hash + '"]');
        var elemOffsetTop = $elem.parentNode.offsetTop;
        $elem.click();
        if (document.querySelector('.main-header--minimal-sticky')) {
            elemOffsetTop -= document.querySelector('.main-header--minimal-sticky').clientHeight;
        }
        window.scrollTo({ top: elemOffsetTop, behavior: "smooth" });
    }
}

_ready(function () {
    var current_url = window.location.href;
    if (current_url.indexOf('/shop-by-solution') != -1) {
        document.addEventListener('click', function (e) {
            var a = e.target.closest('.menu-accoridian ul li .sub-menu li a');
            if (!a) return;
            var href = a.getAttribute('href') || '';
            if (href.indexOf('shop-by-solution#') != -1) {
                document.querySelectorAll('.menu-header .close-menu').forEach(function (el) { el.click(); });
            }
        });
    }
    document.addEventListener('click', function (e) {
        var svg = e.target.closest('.msubmenu svg');
        if (!svg) return;
        var li = svg.closest('li');
        if (!li) return;
        li.classList.toggle('active');
        var sub = li.querySelector('.sub-menu');
        if (sub) _slideToggle(sub);
    });

    document.addEventListener('keyup', function (e) {
        var input = e.target.closest('#phone');
        if (!input) return;
        e.preventDefault();
        var value = input.value;
        var val = input.value.replace(/[^\d]/g, '');
        if (e.key != 'Backspace') {
            if (val.length == 1) {
                val = val.replace(/(\d{1})/, "+1($1");
            } else if (val.length == 5) {
                val = val.replace(/(\d{1})(\d{3})/, "+$1($2) ");
            } else if (val.length == 7) {
                val = val.replace(/(\d{1})(\d{3})(\d{3})/, "+$1($2) $3-");
            } else if (val.length == 8) {
                val = val.replace(/(\d{1})(\d{3})(\d{3})(\d{1})/, "+$1($2) $3-$4");
            } else if (val.length > 11) {
                val = val.substring(0, 11).replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, "+$1($2) $3-$4");
            } else {
                val = value;
            }
            input.value = val;
        }
    });

    var form = document.querySelector('#newsletter-popup-form');
    if (form) form.addEventListener('submit', function (event) {
        event.preventDefault();
        var pn = form.querySelector('#phone');
        if (!pn) return;
        var phoneNumber = pn.value;
        var prev = form.querySelector('.err-msg');
        if (prev) prev.remove();
        _slHide('.success-msg');
        var phoneno = /^[\+][0-9]{1}[(]?[0-9]{3}[)][\s][0-9]{3}[-][0-9]{4}$/im;
        if (phoneNumber.trim() == '' || !phoneno.test(phoneNumber) || phoneNumber.length < 16) {
            var msg = document.createElement('p');
            msg.className = 'err-msg';
            msg.textContent = 'Please enter valid phone number.';
            pn.parentNode.appendChild(msg);
            return;
        }
        fetch('https://vyg.mobi/api/v2/subscriber', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ phoneNumber: phoneNumber, campaignId: 35659 })
        }).then(function () { _slShow('.success-msg'); }).catch(function () {});
    });

});

_ready(function () {
    document.addEventListener('click', function (e) {
        var t = e.target.closest('.close_this');
        if (!t) return;
        e.preventDefault();
        var wrap = t.closest('.gift_product_wrapper');
        if (wrap) wrap.style.display = 'none';
    });

    var frqncy;
    function _setFrequency() {
        if (window.innerWidth > 960) {
            _setName('.template-product .shiipevery.timing_selector .daysinptt', 'shipping_interval_frequency');
            _setName('.shiipevery-select.timing_selector .days-select', '');
            frqncy = '.shiipevery-select.timing_selector';
        } else {
            _setName('.template-product .shiipevery-select.timing_selector .days-select', 'shipping_interval_frequency');
            _setName('.template-product .shiipevery.timing_selector .daysinptt', '');
            frqncy = document.querySelector('.template-collection') ? '.shiipevery.timing_selector' : '.shiipevery-select.timing_selector';
        }
    }
    _setFrequency();
    _clickSel('.shipevery-row #days30');
    document.querySelectorAll('.collection-grid-custom').forEach(function (el) {
        var d = el.querySelector('#days30');
        if (d) d.click();
    });
    window.addEventListener('resize', _setFrequency);

    function _hideQtyWrapName() {
        document.querySelectorAll('.item-quantity-wrap').forEach(function (w) {
            w.style.display = 'none';
            var inp = w.querySelector('input');
            if (inp) inp.removeAttribute('name');
        });
    }
    function _submitSubscription(on) {
        document.querySelectorAll('[data-product-submit]').forEach(function (s) {
            s.classList.toggle('has_subscription', on);
            var ss = s.querySelector('.sub-save'); if (ss) ss.style.display = on ? '' : 'none';
            var ot = s.querySelector('.one-time'); if (ot) ot.style.display = on ? 'none' : '';
        });
    }
    document.querySelectorAll(".template-product .tab-slider--nav li").forEach(function (li) {
        li.addEventListener('click', function () {
            document.querySelectorAll(".tab-slider--body").forEach(function (x) { x.style.display = 'none'; });
            var activeTab = this.getAttribute("rel");
            _fadeIn("#" + activeTab);
            if (activeTab == "tab2") {
                document.querySelectorAll('.tab-slider--tabs').forEach(function (x) { x.classList.add('slide'); });
                if (frqncy) _slideDown(frqncy);
                _submitSubscription(true);
                if (window.innerWidth < 960) {
                    var radio = this.closest('.product-form-grid-radio');
                    var one = radio && radio.querySelector('.bundles-product .option-value-input[data-qty="1"]');
                    if (one) one.click();
                }
                document.querySelectorAll('.product-pack-list').forEach(function (x) { x.classList.add('hide_slide'); });
            } else {
                document.querySelectorAll('.tab-slider--tabs').forEach(function (x) { x.classList.remove('slide'); });
                if (frqncy) _slideUp(frqncy);
                if (window.innerWidth < 960) {
                    document.querySelectorAll('.bundles-product-main .option-values').forEach(function (x) { _slideDown(x); });
                    if (document.querySelector('.product-pack-list.mobile_only')) _hideQtyWrapName();
                } else {
                    if (document.querySelector('.product-pack-list.desk_only')) {
                        document.querySelectorAll('.product-pack-list.desk_only').forEach(function (x) { x.classList.remove('hide_slide'); });
                        _hideQtyWrapName();
                    }
                }
                _submitSubscription(false);
            }
            document.querySelectorAll(".tab-slider--nav li").forEach(function (x) { x.classList.remove("active"); });
            this.classList.add("active");
        });
    });

    document.querySelectorAll(".collapsible-panel-block-content-meta .collapsible-heading").forEach(function (h) {
        h.addEventListener('click', function () {
            document.querySelectorAll(".collapsible-heading").forEach(function (x) { x.classList.remove("active"); });
            document.querySelectorAll(".collapsible-content").forEach(function (x) { _slideUp(x); });
            var nxt = this.nextElementSibling;
            if (nxt && !_visible(nxt)) {
                _slideDown(nxt);
                this.classList.add("active");
            }
        });
    });

document.querySelectorAll('.collapsible-panel-block-heading:not(.notThis)')
  .forEach(function (h) {
    h.addEventListener('click', function () {
      var nxt = this.nextElementSibling;
      var isOpen = this.classList.contains('active');

      // Close every OTHER accordion item.
      document.querySelectorAll('.collapsible-panel-block-heading:not(.notThis)')
        .forEach(function (heading) {
          if (heading !== h) {
            heading.classList.remove('active');
            heading.setAttribute('aria-expanded', 'false');
          }
        });

      document.querySelectorAll('.collapsible-panel-block-content:not(.notThis)')
        .forEach(function (panel) {
          if (panel !== nxt) {
            panel.classList.remove('active');
            _slideUp(panel);
          }
        });

      if (!nxt) return;

      if (isOpen) {
        this.classList.remove('active');
        this.setAttribute('aria-expanded', 'false');
        nxt.classList.remove('active');
        _slideUp(nxt);
      } else {
        nxt.classList.add('active');
        _slideDown(nxt);
        this.classList.add('active');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });



document.querySelectorAll('.collapsible-panel-block-heading.notThis')
  .forEach(function (h) {
    h.addEventListener('click', function () {
      var nxt = this.nextElementSibling;
      var isOpen = this.classList.contains('active');

      // Close every other FAQ item, but never pre-close the target.
      document.querySelectorAll('.collapsible-panel-block-heading.notThis')
        .forEach(function (heading) {
          if (heading !== h) {
            heading.classList.remove('active');
            heading.setAttribute('aria-expanded', 'false');
          }
        });

      document.querySelectorAll('.collapsible-panel-block-content.notThis')
        .forEach(function (panel) {
          if (panel !== nxt) {
            panel.classList.remove('active');
            _slideUp(panel);
          }
        });

      if (!nxt) return;

      if (isOpen) {
        this.classList.remove('active');
        this.setAttribute('aria-expanded', 'false');
        nxt.classList.remove('active');
        _slideUp(nxt);
      } else {
        nxt.classList.add('active');
        _slideDown(nxt);
        this.classList.add('active');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });



    document.querySelectorAll(".collapsible-panel-faq").forEach(function (h) {
        h.addEventListener('click', function () {
            this.classList.toggle("active");
            var nxt = this.nextElementSibling;
            if (nxt) _slideToggle(nxt);
        });
    });

    document.querySelectorAll(".collection-grid-custom .tab-slider--nav li label").forEach(function (lbl) {
        lbl.addEventListener('click', function () {
            var subsave = this.closest('.subsave');
            var rel = subsave ? subsave.getAttribute("rel") : null;
            var card = this.closest('.product-card-interactions');
            var submit = card ? card.querySelector('[data-product-submit]') : null;
            var tabs = this.closest('.tab-slider--tabs');
            var packList = card ? card.querySelector('.product-pack-list') : null;
            var freq = (card && frqncy) ? card.querySelector(frqncy) : null;
            var sub = submit ? submit.querySelector('.sub-save') : null;
            var one = submit ? submit.querySelector('.one-time') : null;
            if (freq) _slideUp(freq);
            if (rel == "tab2") {
                if (tabs) tabs.classList.add('slide');
                if (submit) submit.classList.add('has_subscription');
                if (sub) sub.style.display = '';
                if (one) one.style.display = 'none';
                if (packList) _slideUp(packList);
            } else {
                if (tabs) tabs.classList.remove('slide');
                if (submit) submit.classList.remove('has_subscription');
                if (sub) sub.style.display = 'none';
                if (one) one.style.display = '';
                if (packList) {
                    _slideDown(packList);
                    var pp = card.querySelector('.pack_list-value.active_pack .packprice');
                    var mprice = pp ? pp.getAttribute('data-mprice') : '';
                    var cprice = pp ? pp.getAttribute('data-cprice') : '';
                    if (one) one.innerHTML = (cprice != '' && cprice != null) ? '<del>' + cprice + '</del><span>' + mprice + '</span>' : '<span>' + mprice + '</span>';
                }
            }
            var nav = this.closest(".tab-slider--nav");
            if (nav) nav.querySelectorAll("li").forEach(function (x) { x.classList.remove("active"); });
            var trig = this.closest('.tab-slider--trigger');
            if (trig) trig.classList.add("active");
        });
    });

    var checked = document.querySelector('.template-product .option-value-input:checked');
    _rcSelect(checked ? checked.getAttribute('data-varid') : '');
    if (checked) {
        var radioC = checked.closest('.product-form-grid-radio');
        var strC = radioC ? radioC.querySelector('.strenghwrap') : null;
        var hideSub = strC ? strC.classList.contains('hide_subscribe_for_this') : false;
        if (checked.classList.contains('not_one_qty') || hideSub) {
            var t2 = radioC ? radioC.querySelector('.tab-slider--tabs li[rel="tab2"]') : null;
            if (t2) {
                t2.classList.add('unavailable_subscribe');
                var ut = t2.querySelector('.unavailable_text');
                if (ut) ut.textContent = 'Unavailable for this product';
            }
        } else if (radioC) {
            radioC.querySelectorAll('.strenghwrap:not(.hide_subscribe_for_this)').forEach(function (x) { x.classList.remove('unavailable_subscribe'); });
        }
    }

    document.querySelectorAll('.template-product .option-value-input').forEach(function (inp) {
        inp.addEventListener('change', function () {
            var radio = this.closest('.product-form-grid-radio');
            var activePackEl = document.querySelector('.pack_list-value.active_pack input');
            var activePack = activePackEl ? activePackEl.value : '';
            _rcSelect(this.getAttribute('data-varid'));

            if (this.classList.contains('hideVariantSubscription')) {
                if (radio) {
                    radio.querySelectorAll('li.tab-slider--trigger.subsave').forEach(function (x) { x.classList.add('disable_subscription'); });
                    var t1 = radio.querySelector('.tab-slider--tabs li[rel="tab1"] input');
                    if (t1) t1.click();
                    var un = radio.querySelector('.tab-slider--tabs li[rel="tab2"] .subscription_unavailable');
                    if (un) un.textContent = 'Subscribe & Save Unavailable';
                }
            } else {
                if (radio) {
                    var un2 = radio.querySelector('.tab-slider--tabs li[rel="tab2"] .subscription_unavailable');
                    if (un2) un2.textContent = 'Subscribe & Save';
                }
                var subInner = this.closest('.subscription_inner');
                if (subInner) subInner.querySelectorAll('li.tab-slider--trigger.subsave').forEach(function (x) { x.classList.remove('disable_subscription'); });
            }

            var strwrap = radio ? radio.querySelector('.strenghwrap') : null;
            var hideForThis = strwrap ? strwrap.classList.contains('hide_subscribe_for_this') : false;
            var allTab2 = document.querySelectorAll('.template-product .product-form-grid-radio .tab-slider--tabs li[rel="tab2"]');
            if (this.classList.contains('not_one_qty') || hideForThis) {
                if (radio) {
                    var t1b = radio.querySelector('.tab-slider--tabs li[rel="tab1"] input');
                    if (t1b) t1b.click();
                    if (strwrap) strwrap.classList.add('remove_subsription');
                }
                allTab2.forEach(function (x) { x.classList.add('unavailable_subscribe'); });
            } else {
                allTab2.forEach(function (x) { x.classList.remove('unavailable_subscribe'); });
                if (radio) radio.querySelectorAll('.strenghwrap:not(.hide_subscribe_for_this)').forEach(function (x) { x.classList.remove('remove_subsription'); });
            }

            var pack_mprice = parseInt(this.getAttribute('data-pack-price'));
            var pack_cprice = parseInt(this.getAttribute('data-pack-com-price'));
            if (document.querySelector('.product-pack-list')) {
                document.querySelectorAll('.pack_list-value').forEach(function (pv) {
                    var tl = pv.querySelector('.title-label');
                    var pack = parseInt(tl ? tl.getAttribute('data-pack') : '');
                    var ovn = pv.querySelector('.option-value-name');
                    var percentage = ovn ? ovn.getAttribute('data-pv') : null;
                    var hasPct = percentage != undefined && percentage != '' && percentage != null;
                    var mprice = pack_mprice * pack;
                    var cprice = pack_cprice * pack;
                    var ppe = pv.querySelector('.packprice');
                    if (hasPct) {
                        var final = mprice - (mprice * parseInt(percentage) / 100);
                        if (ppe) { ppe.setAttribute('data-cprice', Shopify.formatMoney(final)); ppe.textContent = Shopify.formatMoney(final); }
                    } else if (ppe) {
                        ppe.setAttribute('data-cprice', Shopify.formatMoney(mprice)); ppe.textContent = Shopify.formatMoney(mprice);
                    }
                    var cp = pv.querySelector('.com-price');
                    if (cp) cp.remove();
                    if (hasPct && ppe) {
                        ppe.setAttribute('data-mprice', Shopify.formatMoney(mprice));
                        ppe.insertAdjacentHTML('afterend', ' <span class="com-price"><del>' + Shopify.formatMoney(mprice) + '</del></span>');
                    } else if (cprice > mprice && ppe) {
                        ppe.setAttribute('data-mprice', Shopify.formatMoney(mprice));
                        ppe.insertAdjacentHTML('afterend', ' <span class="com-price"><del>' + Shopify.formatMoney(cprice) + '</del></span>');
                    }
                });
            }

            var input_var = '';
            var selId = document.querySelector('select[name="id"]');
            var inpId = document.querySelector('input[name="id"]');
            if (selId && selId.value) {
                var opt = document.querySelector('select[name="id"] option[data-option1="' + this.value + '"]');
                input_var = opt ? opt.value : '';
            } else if (inpId && inpId.value) {
                input_var = inpId.value;
            }
            if (input_var != '' && typeof p_img_variant !== 'undefined') {
                var obj_img = p_img_variant.filter(function (variant) { return variant.var_id == input_var; });
                if (parseInt(obj_img.length) > 0) {
                    var ti = document.querySelector('.thumb_inner[data-media="' + obj_img[0].img_id + '"]');
                    if (ti) ti.click();
                }
            }

            var price = this.dataset.price;
            var compare_price = this.dataset.comparePrice;
            var com_price = this.dataset.comPrice;
            var oneTime = radio ? radio.querySelector('[data-product-submit] .one-time') : null;
            var otpPrice = document.querySelector('li.tab-slider--trigger.otp .main_price');
            if (document.querySelector('.pack_list-value.active_pack input[value="3"]')) {
                var apPrice = radio ? radio.querySelector('.pack_list-value.active_pack .packprice') : null;
                var old_price = apPrice ? apPrice.getAttribute('data-cprice') : '';
                var new_price = apPrice ? apPrice.getAttribute('data-mprice') : '';
                if (oneTime) oneTime.innerHTML = '<span>' + old_price + '</span><del>' + new_price + '</del>';
                if (otpPrice) otpPrice.innerHTML = '<span>' + old_price + '</span><del>' + new_price + '</del>';
            } else if (compare_price) {
                if (otpPrice) otpPrice.innerHTML = '<span>' + price + '</span><del>' + compare_price + '</del>';
                if (oneTime) oneTime.innerHTML = '<span>' + price + '</span><del>' + compare_price + '</del>';
            } else {
                if (otpPrice) otpPrice.innerHTML = '<span>' + price + '</span>';
                if (oneTime) oneTime.innerHTML = '<span>' + price + '</span>';
            }
            var subSave = radio ? radio.querySelector('[data-product-submit] .sub-save') : null;
            if (subSave) subSave.innerHTML = '<span>' + com_price + '</span><del>' + price + '</del>';
            var apInput = document.querySelector('.product-pack-list.desk_only .pack_list-value input[value="' + activePack + '"]');
            if (apInput && apInput.parentElement) { apInput.parentElement.click(); apInput.parentElement.classList.add('active_pack'); }
        });
    });



    document.addEventListener('click', function (e) {
        var t = e.target.closest('.thumb_inner');
        if (!t || !e.isTrusted) return;
        if (typeof p_img_variant === 'undefined') return;
        var cur_img_id = t.getAttribute('data-media');
        var obj_img = p_img_variant.filter(function (variant) { return variant.img_id == cur_img_id; });
        if (parseInt(obj_img.length) <= 0) return;
        var opt = document.querySelector('select[name="id"] option[data-variant-id="' + obj_img[0].var_id + '"]')
            || document.querySelector('input[name="id"] option[data-variant-id="' + obj_img[0].var_id + '"]');
        if (!opt) return;
        var d1 = opt.getAttribute('data-option1');
        var d2 = opt.getAttribute('data-option2');
        var d3 = opt.getAttribute('data-option3');
        if (d1 != '') { var r1 = document.querySelector('.option-values[data-op_index="1"] input.option-value-input[value="' + d1 + '"]'); if (r1) r1.checked = true; }
        if (d2 != '') { var r2 = document.querySelector('.option-values[data-op_index="2"] input.option-value-input[value="' + d1 + '"]'); if (r2) r2.checked = true; }
        if (d3 != '') { var r3 = document.querySelector('.option-values[data-op_index="3"] input.option-value-input[value="' + d1 + '"]'); if (r3) r3.checked = true; }
    });


    document.querySelectorAll('.collection-grid-custom').forEach(function (grid) {
        var col_var = grid.querySelector('.option-value-input:checked');
        if (!col_var) return;
        var card = col_var.closest('.product-card-interactions');
        var d = col_var.dataset;
        var price = d.price, compare_price = d.comparePrice, save_price = d.savePrice, com_price = d.comPrice;
        var btn_cart = d.cart == 'true' || d.cart == '1';
        var data_id = d.id, qty = d.qty;
        var badge = grid.querySelector('.badge-sale');
        if (badge) {
            if (save_price) { badge.style.display = ''; badge.textContent = 'SAVE ' + save_price; }
            else { badge.style.display = 'none'; }
        }
        if (!card) return;
        var qi = card.querySelector('.product-quantity-input'); if (qi) qi.value = qty;
        var mainPrice = card.querySelector('.main_price');
        if (mainPrice) mainPrice.innerHTML = compare_price ? '<span class="money">' + price + '</span><del>' + com_price + '</del>' : '<span class="money">' + price + '</span>';
        var subDisc = card.querySelector('.sub_discount_price'); if (subDisc) subDisc.textContent = com_price;
        var submit = card.querySelector('[data-product-submit]');
        if (submit) {
            var avail = submit.querySelector('.product-card-interaction-addtocart-available');
            if (btn_cart) {
                if (avail) avail.textContent = 'ADD TO CART';
                if (card.querySelector('.add_into_popup')) {
                    var pop = submit.querySelector('.add_into_popup.product-card-interaction-addtocart-available');
                    if (pop) pop.textContent = 'Add to cart';
                }
                submit.disabled = false;
            } else {
                if (avail) avail.textContent = 'Sold Out';
                submit.disabled = true;
            }
            var subSave = submit.querySelector('.sub-save'); if (subSave) subSave.innerHTML = '<del>' + price + '</del><span>' + com_price + '</span>';
            submit.setAttribute('data-product-variant-id', data_id);
        }
        _rcSelectIn(card, col_var.getAttribute('data-varid'));

        var strwrap = card.querySelector('.strenghwrap');
        var hideForThis = strwrap ? strwrap.classList.contains('hide_subscribe_for_this') : false;
        if (col_var.classList.contains('not_one_qty') || hideForThis) {
            var t1lbl = card.querySelector('.tab-slider--tabs li[rel="tab1"] label'); if (t1lbl) t1lbl.click();
            if (strwrap) { _slideUp(strwrap); strwrap.classList.add('remove_subsription'); }
        } else {
            card.querySelectorAll('.strenghwrap:not(.hide_subscribe_for_this)').forEach(function (x) { _slideDown(x); x.classList.remove('remove_subsription'); });
        }
        var packList = card.querySelector('.product-pack-list');
        if (packList) {
            var at = card.querySelector('.tab-slider--trigger.active');
            (at && at.getAttribute('rel') == 'tab1') ? _slideDown(packList) : _slideUp(packList);
        }
    });


    document.addEventListener('change', function (e) {
        var col_var = e.target.closest('.collection-grid-custom .option-value-input');
        if (!col_var) return;
        var card = col_var.closest('.product-card-interactions');
        _rcSelectIn(card, col_var.getAttribute('data-varid'));

        var productInner = col_var.closest('.product-inner');
        if (col_var.classList.contains('hideVariantSubscription')) {
            if (productInner) {
                productInner.querySelectorAll('li.tab-slider--trigger.subsave').forEach(function (x) { x.classList.add('disable_subscription'); });
                var t1 = productInner.querySelector('.tab-slider--tabs li[rel="tab1"] label'); if (t1) t1.click();
            }
        } else if (productInner) {
            productInner.querySelectorAll('li.tab-slider--trigger.subsave').forEach(function (x) { x.classList.remove('disable_subscription'); });
        }

        var strwrap = card ? card.querySelector('.strenghwrap') : null;
        var hideForThis = strwrap ? strwrap.classList.contains('hide_subscribe_for_this') : false;
        if (col_var.classList.contains('not_one_qty') || hideForThis) {
            if (card) { var t1b = card.querySelector('.tab-slider--tabs li[rel="tab1"] label'); if (t1b) t1b.click(); }
            if (strwrap) { strwrap.classList.add('remove_subsription'); _slideUp(strwrap); }
        } else if (card) {
            card.querySelectorAll('.strenghwrap:not(.hide_subscribe_for_this)').forEach(function (x) { x.classList.remove('remove_subsription'); _slideDown(x); });
        }

        var d = col_var.dataset;
        var price = d.price, compare_price = d.comparePrice, save_price = d.savePrice, com_price = d.comPrice;
        var btn_cart = d.cart == 'true' || d.cart == '1';
        var data_id = d.id, qty = d.qty;
        var grid = col_var.closest('.collection-grid-custom');
        var badge = grid ? grid.querySelector('.badge-sale') : null;
        if (badge) {
            if (save_price) { badge.style.display = ''; badge.textContent = 'SAVE ' + save_price; }
            else { badge.style.display = 'none'; }
        }
        if (!card) return;
        var qi = card.querySelector('.product-quantity-input'); if (qi) qi.value = qty;
        var mainPrice = card.querySelector('.main_price');
        if (mainPrice) mainPrice.innerHTML = compare_price ? '<span class="money">' + price + '</span><del>' + compare_price + '</del>' : '<span class="money">' + price + '</span>';
        var subDisc = card.querySelector('.sub_discount_price'); if (subDisc) subDisc.textContent = com_price;
        var submit = card.querySelector('[data-product-submit]');
        var oneTime = submit ? submit.querySelector('.one-time') : null;
        if (oneTime) oneTime.innerHTML = compare_price ? '<del>' + compare_price + '</del><span>' + price + '</span>' : '<span>' + price + '</span>';
        if (submit) {
            var subSave = submit.querySelector('.sub-save'); if (subSave) subSave.innerHTML = '<del>' + price + '</del><span>' + com_price + '</span>';
            submit.setAttribute('data-product-variant-id', data_id);
            var avail = submit.querySelector('.product-card-interaction-addtocart-available');
            if (btn_cart) {
                if (avail) avail.textContent = 'ADD TO CART';
                if (card.querySelector('.add_into_popup')) {
                    var pop = submit.querySelector('.add_into_popup.product-card-interaction-addtocart-available'); if (pop) pop.textContent = 'Add to cart';
                }
                submit.disabled = false;
            } else {
                if (avail) avail.textContent = 'Sold Out';
                submit.disabled = true;
            }
        }

        var pack_mprice = parseInt(col_var.getAttribute('data-pack-price'));
        var pack_cprice = parseInt(col_var.getAttribute('data-pack-com-price'));
        if (card.querySelector('.product-pack-list')) {
            card.querySelectorAll('.pack_list-value').forEach(function (pv) {
                var tl = pv.querySelector('.title-label');
                var pack = parseInt(tl ? tl.getAttribute('data-pack') : '');
                var ovn = pv.querySelector('.option-value-name');
                var percentage = ovn ? ovn.getAttribute('data-pv') : null;
                var hasPct = percentage != undefined && percentage != '' && percentage != null;
                var mprice = pack_mprice * pack;
                var cprice = pack_cprice * pack;
                if (hasPct) mprice = mprice - (mprice * parseInt(percentage) / 100);
                var ppe = pv.querySelector('.packprice');
                if (ppe) { ppe.textContent = Shopify.formatMoney(mprice); ppe.setAttribute('data-mprice', Shopify.formatMoney(mprice)); ppe.setAttribute('data-cprice', ''); }
                var cp = pv.querySelector('.com-price'); if (cp) cp.remove();
                if (hasPct) {
                    if (ppe) {
                        ppe.setAttribute('data-mprice', Shopify.formatMoney(mprice));
                        ppe.setAttribute('data-cprice', Shopify.formatMoney(pack_mprice * pack));
                        ppe.insertAdjacentHTML('afterend', ' <span class="com-price"><del>' + Shopify.formatMoney(pack_mprice * pack) + '</del></span>');
                    }
                    var at = card.querySelector('.tab-slider--trigger.active');
                    if (at && at.getAttribute('rel') == 'tab1' && pv.classList.contains('active_pack') && oneTime) {
                        oneTime.innerHTML = '<del>' + Shopify.formatMoney(pack_mprice * pack) + '</del><span>' + Shopify.formatMoney(mprice) + '</span>';
                    }
                } else if (cprice > mprice && ppe) {
                    ppe.setAttribute('data-mprice', Shopify.formatMoney(mprice));
                    ppe.setAttribute('data-cprice', Shopify.formatMoney(cprice));
                    ppe.insertAdjacentHTML('afterend', ' <span class="com-price"><del>' + Shopify.formatMoney(cprice) + '</del></span>');
                }
            });
        }
    });

});
_ready(function () {
    function _setDropdownTop() {
        var header = document.querySelector('.main-header-wrap.main-header--minimal-sticky');
        var hg = header ? header.offsetHeight : 0;
        document.querySelectorAll('.mobile-dropdown').forEach(function (el) { el.style.top = hg + 'px'; });
    }
    _setDropdownTop();
    window.addEventListener('resize', function () {
        _setDropdownTop();
        var dropdown = document.querySelector('.mobile-dropdown');
        if (window.innerWidth > 959) {
            document.documentElement.classList.remove('scroll-locked');
        } else if (dropdown && dropdown.classList.contains('active')) {
            document.documentElement.classList.add('scroll-locked');
        }
    });

    function _clearRechargePopup() {
        _setName('.quantity_selector_normal', 'quantity');
        var rc = document.querySelector('.quantity_selector_rc'); if (rc) rc.removeAttribute('name');
        document.querySelectorAll('.addcartpopup-overlay, .addcartpopup-wrap, .addcart-popup-recharge').forEach(function (el) { el.classList.remove('active'); });
        document.documentElement.classList.remove('scroll-locked');
        document.body.classList.remove('recharge_active-popup');
        document.body.classList.remove('active-popup');
        document.querySelectorAll('.strenghwrap').forEach(function (el) { el.classList.add('has_default'); });
        var overlay = document.querySelector('.cm-add-popup-overlay'); if (overlay) overlay.classList.remove('active');
        var dest = document.querySelector('.add-tocart-popup'); if (dest) dest.innerHTML = '';
    }
    function _clickAll(sel) { document.querySelectorAll(sel).forEach(function (el) { el.click(); }); }

    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.popup-btn');
        if (!btn) return;
        e.preventDefault();
        var cur = btn.getAttribute('data-popup-pro');
        var wrap = document.querySelector('#' + cur + ' .addcartpopup-wrap');
        if (wrap) wrap.classList.add('active');
        document.querySelectorAll('.addcartpopup-overlay').forEach(function (el) { el.classList.add('active'); });
        var activeWrap = document.querySelector('.addcartpopup-wrap.active');
        var dest = document.querySelector('.add-tocart-popup');
        if (activeWrap && dest) { var clone = activeWrap.cloneNode(true); clone.style.display = ''; dest.appendChild(clone); }
        document.querySelectorAll('.featured-collection-carousel-membership .addcart-popup .addcartpopup-wrap').forEach(function (el) { el.style.display = 'none'; });
        document.documentElement.classList.add('scroll-locked');
        document.body.classList.add('active-popup');
    });

    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.product-submit-recharge');
        if (!btn) return;
        e.preventDefault();
        var pt = document.querySelector('[name="purchase_type"]:checked');
        if (pt && pt.value == 'autodeliver') {
            document.querySelectorAll('[data-product-submit]').forEach(function (el) { el.classList.add('has_normal'); el.click(); });
        } else {
            var cur = btn.getAttribute('data-popup-pro');
            var pop = document.getElementById(cur); if (pop) pop.classList.add('active');
            document.body.classList.add('recharge_active-popup');
            document.querySelectorAll('.strenghwrap').forEach(function (el) { el.classList.remove('has_default'); });
            var overlay = document.querySelector('.cm-add-popup-overlay'); if (overlay) overlay.classList.add('active');
            var qn = document.querySelector('.quantity_selector_normal'); if (qn) qn.removeAttribute('name');
            _setName('.quantity_selector_rc', 'quantity');
            document.querySelectorAll('[data-product-submit]').forEach(function (el) { el.classList.add('has_subscription'); });
        }
    });

    document.addEventListener('click', function (e) {
        if (!e.target.closest('.addcart-popup-recharge .addproduct_normal')) return;
        e.preventDefault();
        _clearRechargePopup();
        document.querySelectorAll('[data-product-submit]').forEach(function (el) { el.classList.remove('has_subscription'); el.click(); });
    });

    document.addEventListener('click', function (e) {
        if (!e.target.closest('.addcart-popup-recharge .addproduct_sub')) return;
        e.preventDefault();
        _clickAll('[data-product-submit]');
        document.querySelectorAll('.strenghwrap').forEach(function (el) { el.classList.add('has_default'); });
    });

    document.addEventListener('click', function (e) {
        if (!e.target.closest('.addcartpopup-overlay, .addcartpopup-wrap .close-popup, .cm-add-popup-overlay, .addcart-popup-recharge-inner .close-popup')) return;
        e.preventDefault();
        _clearRechargePopup();
    });

    document.querySelectorAll('.faq-question').forEach(function (q) {
        q.addEventListener('click', function (e) {
            e.preventDefault();
            document.querySelectorAll('.faq-answre').forEach(function (a) { _slideUp(a); });
            document.querySelectorAll('.faq-question').forEach(function (fq) {
                if (fq.parentNode) fq.parentNode.classList.remove('active');
                fq.setAttribute('aria-expanded', 'false');
            });
            var ans = this.parentNode ? this.parentNode.querySelector('.faq-answre') : null;
            if (ans && !_visible(ans)) {
                _slideToggle(ans);
                this.parentNode.classList.toggle('active');
                this.setAttribute('aria-expanded', 'true');
            }
        });
    });

    document.querySelectorAll('.graph-section').forEach(function (el) { el.classList.add('draw'); });

    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.add_to_col_cart');
        if (!btn) return;
        e.preventDefault();
        var cc = btn.getAttribute('data-cart');
        var ct = btn.querySelector('.cart_text'); if (ct) ct.style.display = 'none';
        var sp = btn.querySelector('.product-card-interaction-addtocart-spinner'); if (sp) sp.style.display = '';
        setTimeout(function () {
            document.querySelectorAll('.addcart-container .cart_text').forEach(function (el) { el.style.display = ''; });
            document.querySelectorAll('.addcart-container .product-card-interaction-addtocart-spinner').forEach(function (el) { el.style.display = 'none'; });
            document.querySelectorAll('.addcartpopup-overlay, .addcartpopup-wrap').forEach(function (el) { el.classList.remove('active'); });
            document.documentElement.classList.remove('scroll-locked');
            document.body.classList.remove('active-popup');
            if (cc) _clickAll('.' + cc);
            var dest = document.querySelector('.add-tocart-popup'); if (dest) dest.innerHTML = '';
        }, 1000);
    });

    document.addEventListener('click', function (e) {
        var a = e.target.closest('.shop-by-solutions-header li a.not-redirect');
        if (!a) return;
        e.preventDefault();
        var toph = a.getAttribute('href');
        document.querySelectorAll('.shop-by-solutions-header li a').forEach(function (x) { x.classList.remove('active'); });
        a.classList.add('active');
        var target = toph ? document.querySelector(toph) : null;
        if (!target) return;
        var st;
        if (window.innerWidth > 767) {
            var head = document.querySelector('.shop-by-solution-header');
            st = target.getBoundingClientRect().top + window.pageYOffset - (head ? head.offsetHeight : 0) - 70;
        } else {
            st = target.getBoundingClientRect().top + window.pageYOffset - 170;
        }
        window.scrollTo({ top: st, behavior: 'smooth' });
    });

    var learnMore = document.querySelector('#learn-more');
    if (learnMore) learnMore.addEventListener('click', function () {
        var target = document.querySelector('#shopify-section-membership-how-work');
        if (target) window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - 20, behavior: 'smooth' });
    });

    var welPop = document.querySelector('.wel_back_pop');
    var cookieExpireSet = welPop ? welPop.getAttribute('data-cookie-interval') : null;
    var NewsletterCookie = "premium-customer-cookie";

    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    if (welPop) {
        welPop.classList.toggle('active_popup', !getCookie(NewsletterCookie));
    }
    document.querySelectorAll('.wel_close_icon , .pop_overlay').forEach(function (el) {
        el.addEventListener('click', function () {
            if (welPop) welPop.classList.remove('active_popup');
            setCookie(NewsletterCookie, '1', cookieExpireSet);
        });
    });
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.premium-shop-now');
        if (!btn) return;
        if (welPop) welPop.classList.remove('active_popup');
        setCookie(NewsletterCookie, '1', cookieExpireSet);
        var url = btn.getAttribute('data-href');
        if (url) window.location = url;
    });

});



window.addEventListener('scroll', function () {
    var header = document.querySelector('header');
    var height_top = header ? header.offsetHeight : 0;
    var sbs = document.querySelector('.shop-by-solution-header');
    var cmw = document.querySelector('.cm-main-wrapper');
    if (window.pageYOffset > height_top) {
        if (sbs) { sbs.classList.add('fixed'); sbs.style.top = height_top + 'px'; }
        if (cmw) cmw.classList.add('fixed');
    } else {
        if (sbs) { sbs.classList.remove('fixed'); sbs.style.top = '0px'; }
        if (cmw) cmw.classList.remove('fixed');
    }
    _stickyBtn('button.product-submit', '.qty-atc-wrapper');
    _stickyBtn('button.add_to_cart_btn', '.add_cart_wpr');
});

_ready(function () {
    if (window.location.href.indexOf('/shop-by-solution#') === -1) return;
    var toph = window.location.href.split('#')[1];
    document.querySelectorAll('.shop_by_solutions_header li a').forEach(function (x) { x.classList.remove('active'); });
    var target = document.getElementById(toph);
    if (!target) return;
    var st;
    if (window.innerWidth > 767) {
        var head = document.querySelector('.shop-by-solution-header');
        st = target.getBoundingClientRect().top + window.pageYOffset - (head ? head.offsetHeight : 0) - 70;
    } else {
        st = target.getBoundingClientRect().top + window.pageYOffset - 180;
    }
    window.scrollTo({ top: st, behavior: 'smooth' });
});

function ChangeUrl(page, url) {
    if (typeof (history.pushState) != "undefined") {
        history.pushState({ Page: page, Url: url }, page, url);
    } else {
        alert("Browser does not support HTML5.");
    }
}
document.querySelectorAll('li.redirect').forEach(function (li) {
    li.addEventListener('click', function () {
        var href_link = this.getAttribute('data-href') || '';
        if (href_link.indexOf('/shop-by-solution#') > -1) {
            ChangeUrl('url', href_link);
            window.location.reload();
        }
    });
});

function _shopByCategoryNav() {
    document.querySelectorAll('.shop-by-category').forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var elementTop = rect.top + window.pageYOffset;
        var elementBottom = elementTop + el.offsetHeight / 2;
        var viewportTop = window.pageYOffset;
        var viewportHalf = viewportTop + window.innerHeight / 2;
        if (!(elementBottom > viewportTop && elementTop < viewportHalf)) return;
        var cur_section = el.getAttribute('id');
        var navLink = document.querySelector('.mobile-shop-by-solution-nav-swiper li[data-current="' + cur_section + '"]');
        var _navSlide = navLink ? navLink.closest('.swiper-slide') : null;
        if (window.__mobileSolutionSwiper && _navSlide) window.__mobileSolutionSwiper.slideTo(Array.prototype.indexOf.call(_navSlide.parentNode.children, _navSlide));
        document.querySelectorAll('.mobile-shop-by-solution-nav-swiper li a').forEach(function (a) { a.classList.remove('active'); });
        var activeA = document.querySelector('.mobile-shop-by-solution-nav-swiper li[data-current="' + cur_section + '"] a');
        if (activeA) activeA.classList.add('active');
    });
}
window.addEventListener('load', _shopByCategoryNav);
window.addEventListener('resize', _shopByCategoryNav);
window.addEventListener('scroll', _shopByCategoryNav);
document.querySelectorAll('.mobile-shop-by-solution-nav-swiper ul li a').forEach(function (a) {
    a.addEventListener('click', function () {
        var anchor = this.getAttribute('href');
        var el = anchor ? document.querySelector(anchor) : null;
        if (!el || !el.parentNode) return;
        el.classList.add('active');
        Array.prototype.forEach.call(el.parentNode.children, function (s) { if (s !== el) s.classList.remove('active'); });
    });
});

var _countdownEl = document.querySelector('#countdown');
var starttime = _countdownEl ? _countdownEl.getAttribute('data-start-time') : null;
var endtime = _countdownEl ? _countdownEl.getAttribute('data-end-time') : null;

function progress(el) {
    if (!el) return;
    var start = new Date(starttime).getTime();
    var end = new Date(endtime).getTime();
    var current = new Date().getTime();
    end = Number(end) - Number(start), current = Number(current) - Number(start), start = 0;
    var width = (current * 100) / end;
    var div = el.querySelector('div');
    if (div) div.style.width = width + '%';
}
(function() {
    var now = new Date().getTime();

    var countDownDate = new Date(endtime).getTime();
    var time_cur = parseInt(countDownDate) - parseInt(now);
    if (time_cur > 0) {
        document.querySelectorAll('.counttimer').forEach(function(e){e.style.display='';});
        let countdown = document.getElementById("countdown")
        let n_now = new Date().getTime(),
            leftitme = countDownDate - n_now;
        var new_left_tile = Math.floor((leftitme / 1000));
        var x = setInterval(function() {
            let now = new Date().getTime(),
                distance = countDownDate - now;
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            if (days < 10) {
                days = '0' + days;
            }
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            if (hours < 10) {
                hours = '0' + hours;
            }
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            if (minutes < 10) {
                minutes = '0' + minutes;
            }
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            if (seconds < 10) {
                seconds = '0' + seconds;
            }
            progress(document.querySelector('#progressBar'));
            // Output the result in an element with id="demo"
            _setText('#days', days);
            _setText('#hours', hours);
            _setText('#minutes', minutes);
            _setText('#seconds', seconds);
            // If the count down is over, write some text 
            if (distance < 0) {
                let countdown = document.getElementById("countdown")
                countdown.style.display = "none";
                clearInterval(x);
            }
        }, 1000);
    } else {
        document.querySelectorAll('.counttimer').forEach(function(e){e.style.display='none';});
    }
}());


(function() {
    var now = new Date().getTime();
    var endtime = (_countdownEl ? _countdownEl.getAttribute('data-end-time') : null);
    var countDownDate = new Date(endtime).getTime();
    var time_cur = parseInt(countDownDate) - parseInt(now);
    if (time_cur > 0) {
        document.querySelectorAll('.counttimer').forEach(function(e){e.style.display='';});
        document.body.classList.add('timer_count');
        let countdown = document.getElementById("countdownmob")
        let n_now = new Date().getTime(),
            leftitme = countDownDate - n_now;
        var new_left_tile = Math.floor((leftitme / 1000));
        var x = setInterval(function() {
            let now = new Date().getTime(),
                distance = countDownDate - now;
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            if (days < 10) {
                days = '0' + days;
            }
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            if (hours < 10) {
                hours = '0' + hours;
            }
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            if (minutes < 10) {
                minutes = '0' + minutes;
            }
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            if (seconds < 10) {
                seconds = '0' + seconds;
            }
            progress(document.querySelector('#progressBarmob'));
            // Output the result in an element with id="demo"
            _setText('#daysmob', days);
            _setText('#hoursmob', hours);
            _setText('#minutesmob', minutes);
            _setText('#secondsmob', seconds);
            // If the count down is over, write some text 
            if (distance < 0) {
                let countdown = document.getElementById("countdownmob")
                countdown.style.display = "none";
                clearInterval(x);
            }
        }, 1000);

    } else {
        document.querySelectorAll('.counttimer').forEach(function(e){e.style.display='none';});
        document.body.classList.remove('timer_count');
    }
}());

window.addEventListener('scroll', function () {
    var isMobile = window.innerWidth < 768;
    var hEl = document.querySelector(isMobile ? '.main-header' : 'header');
    var height_top = hEl ? hEl.offsetHeight : 0;
    var header = document.querySelector('header');
    var bar = document.querySelector('#shopify-section-pxs-announcement-bar');
    var st = window.pageYOffset;
    if (st > (isMobile ? height_top : 1)) {
        if (header) header.classList.add('sticky-header');
        if (bar && st > 50) bar.style.paddingTop = height_top + 'px';
    } else {
        if (header) header.classList.remove('sticky-header');
        if (bar) bar.style.paddingTop = '0px';
    }
});
_ready(function () {
    if (document.querySelector('.template-product .tab-slider--trigger.check-trigger')) {
        var activeTrig = document.querySelector('.template-product .tab-slider--trigger.check-trigger.active');
        if ((!activeTrig || activeTrig.getAttribute('rel') != 'tab2') && document.querySelector('.template--product .product-pack-list')) {
            var inp = document.querySelector('.product-form-grid-radio .product-pack-list.desk_only .pack_list-value.active_pack input');
            if (inp) inp.click();
        }
    }

    document.querySelectorAll('.has-item > a').forEach(function (a) {
        a.addEventListener('click', function () {
            document.querySelectorAll('.has-item > a').forEach(function (x) { x.classList.remove('activelink'); });
            this.classList.add('activelink');
            var tagid = this.getAttribute('data-tag');
            document.querySelectorAll('.tabbmenu').forEach(function (x) { x.classList.remove('active'); x.classList.add('hide'); });
            var tab = document.getElementById(tagid);
            if (tab) { tab.classList.add('active'); tab.classList.remove('hide'); }
        });
    });
});
window.addEventListener('load', function () {
    _syncMainPriceDel();

    document.querySelectorAll('.collection-grid-custom').forEach(function (grid) {
        if (!grid.classList.contains('hideVariant-found')) return;
        var inp = grid.querySelector('.option-value:first-child .option-value-input');
        if (inp) inp.click();
    });

    if (document.querySelector('.template-product .tab-slider--trigger.check-trigger')) {
        var activeTrig = document.querySelector('.template-product .tab-slider--trigger.check-trigger.active');
        if ((!activeTrig || activeTrig.getAttribute('rel') != 'tab2') && document.querySelector('.template--product .product-pack-list')) {
            var packInp = document.querySelector('.product-form-grid-radio .product-pack-list.desk_only .pack_list-value.active_pack input');
            if (packInp) packInp.click();
        }
    }

    if (document.querySelector('body.template--page-contact')) {
        var href = window.location.href;
        var updateAriaLabels = function () {
            document.querySelectorAll('.content-area .contact-tabs .tab-heading input').forEach(function (inp) {
                var th = inp.closest('.tab-heading');
                inp.setAttribute('aria-label', th && th.classList.contains('active') ? 'selected' : 'not selected');
            });
        };
        if (href.indexOf('#') > -1) {
            var id = href.split('#');
            document.querySelectorAll('.content-area .contact-tabs .tab-heading').forEach(function (x) { x.classList.remove('active'); });
            document.querySelectorAll('.text-content-wrap .full-width-form').forEach(function (x) { x.classList.remove('active'); });
            var inpH = document.querySelector('.content-area .contact-tabs input[data-href="#' + id[1] + '"]');
            var thH = inpH ? inpH.closest('.tab-heading') : null;
            if (thH) thH.classList.add('active');
            var target = document.querySelector('.text-content-wrap #' + id[1]);
            if (target) target.classList.add('active');
        } else {
            var firstTab = document.querySelector('.content-area .contact-tabs .tab-heading');
            if (firstTab) firstTab.classList.add('active');
            var firstInp = firstTab ? firstTab.querySelector('input') : null;
            var id2 = firstInp ? firstInp.getAttribute('data-href') : null;
            if (id2) { var t2 = document.querySelector('.text-content-wrap ' + id2); if (t2) t2.classList.add('active'); }
        }
        updateAriaLabels();
        document.querySelectorAll('.content-area .contact-tabs .tab-heading').forEach(function (th) {
            th.addEventListener('click', function () {
                document.querySelectorAll('.content-area .contact-tabs .tab-heading').forEach(function (x) { x.classList.remove('active'); });
                document.querySelectorAll('.text-content-wrap .full-width-form').forEach(function (x) { x.classList.remove('active'); });
                this.classList.add('active');
                var inp = this.querySelector('input');
                var idc = inp ? inp.getAttribute('data-href') : null;
                if (idc) { var t = document.querySelector('.text-content-wrap ' + idc); if (t) t.classList.add('active'); }
                updateAriaLabels();
            });
        });
    }
});
_ready(function () {
    _syncMainPriceDel();

    if (document.querySelectorAll('.template-product .option-values .option-value').length == 1) {
        document.querySelectorAll('.template-product .option-values .option-value').forEach(function (x) { x.classList.add('has_single_option'); });
        document.querySelectorAll('.template-product .option-values').forEach(function (x) { x.classList.add('has_single_option_main'); });
        document.querySelectorAll('.template-product .option-header').forEach(function (x) { x.classList.add('has_single_option_header'); });
        document.querySelectorAll('.template-product .subscription_inner').forEach(function (x) { x.classList.add('has_single_subscription_inner'); });
    }

    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.section-membership-new-hero .action-button');
        if (!btn) return;
        var url = btn.getAttribute('href') || '';
        if (url.indexOf('#') == -1) return;
        e.preventDefault();
        var frag = url.split('#')[1];
        if (frag == '') return;
        var target = document.getElementById(frag);
        var header = document.querySelector('header');
        if (target) window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - (header ? header.offsetHeight : 0), behavior: 'smooth' });
    });

    var _bodyClass = function (c) { document.body.classList.add(c); };
    if (navigator.appVersion.indexOf("Win") != -1) _bodyClass('window-os');
    if (navigator.platform.toUpperCase().indexOf('MAC') >= 0) _bodyClass('mac-os');
    if (navigator.appVersion.indexOf("Linux") != -1) _bodyClass('linux-os');
    var trident = !!navigator.userAgent.match(/Trident\/7.0/);
    var net = !!navigator.userAgent.match(/.NET4.0E/);
    if ((trident && net) || navigator.userAgent.match(/MSIE/i)) _bodyClass('ie');
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') != -1) _bodyClass(ua.indexOf('chrome') > -1 ? 'isChrome' : 'isSafari');
    if (!(window.mozInnerScreenX == null)) _bodyClass('fire-fox');

    document.addEventListener('change', function (e) {
        var sel = e.target.closest('.collection_product__grid_new .product-variant-dropdown select[name="id"]');
        if (!sel) return;
        var form = sel.closest('form');
        if (!form) return;
        var opt = sel.options[sel.selectedIndex];
        var repeatBtn = form.querySelector('.repeat-btn.has_subscription');
        if (opt && opt.getAttribute('data-subscribe-hide') == 'true') {
            if (repeatBtn) repeatBtn.style.display = 'none';
        } else {
            var sp = form.querySelector('.repeat-btn.has_subscription .subscribe_price');
            if (sp) sp.textContent = opt ? opt.getAttribute('data-subscribe-price') : '';
            if (repeatBtn) repeatBtn.style.display = '';
        }
        var bo = form.querySelector('.pg-btn .buy_once_price');
        if (bo) bo.textContent = opt ? opt.getAttribute('data-price') : '';
    });

});
document.addEventListener('click', function (e) {
    var pv = e.target.closest('.product-details-wrapper .product-pack-list .pack_list-value');
    if (!pv) return;
    e.preventDefault();
    var radio = pv.closest('.product-form-grid-radio');
    if (radio) radio.querySelectorAll('.pack_list-value').forEach(function (x) { x.classList.remove('active_pack'); });
    pv.classList.add('active_pack');
    var inp = pv.querySelector('input'); if (inp) inp.checked = true;
    var ppe = pv.querySelector('.packprice');
    var mprice = ppe ? ppe.getAttribute('data-mprice') : null;
    var cprice = ppe ? ppe.getAttribute('data-cprice') : null;
    var html = mprice ? '<span>' + cprice + '</span><del>' + mprice + '</del>' : '<span>' + cprice + '</span>';
    var otp = document.querySelector('li.tab-slider--trigger.otp .main_price');
    if (otp) otp.innerHTML = html;
    var oneTime = radio ? radio.querySelector('[data-product-submit] .one-time') : null;
    if (oneTime) oneTime.innerHTML = html;
    var allTab2 = document.querySelectorAll('.template-product .product-form-grid-radio .tab-slider--tabs li[rel="tab2"]');
    if (inp && parseInt(inp.value) == 1) {
        allTab2.forEach(function (x) { x.classList.remove('unavailable_subscribe'); });
    } else {
        allTab2.forEach(function (x) { x.classList.add('unavailable_subscribe'); });
        var otpInput = document.querySelector('.template-product .product-form-grid-radio .tab-slider--tabs li[rel="tab1"] input#otpinpt');
        if (otpInput) otpInput.click();
    }
});

document.addEventListener('click', function (e) {
    var pv = e.target.closest('.product-card-interactions .product-pack-list .pack_list-value');
    if (!pv) return;
    var list = pv.closest('.product-pack-list');
    if (list) list.querySelectorAll('.pack_list-value').forEach(function (x) { x.classList.remove('active_pack'); });
    pv.classList.add('active_pack');
    var ppe = pv.querySelector('.packprice');
    var mprice = ppe ? ppe.getAttribute('data-mprice') : null;
    var cprice = ppe ? ppe.getAttribute('data-cprice') : null;
    var card = pv.closest('.product-card-interactions');
    var oneTime = card ? card.querySelector('[data-product-submit] .one-time') : null;
    if (oneTime) oneTime.innerHTML = '<del>' + cprice + '</del><span>' + mprice + '</span>';
});
window.addEventListener('load', function () {
    setTimeout(function () {
        var g = document.querySelector('#gorgias-chat-container');
        if (g) g.style.display = '';
    }, 10000);
});


function checkbtn() {
    function appendbtn() {
        if (!document.querySelector('#__next')) return;
        var container = document.querySelector('.F6l.Jea.Uex.XBe.hA-.k1A.kzZ.wYR.zI7.iyn.Hsu');
        if (!container) return;
        var logoutBtn = '<div class="C9q Shl zI7 iyn Hsu logout_btn"><div class="FNs zI7 iyn Hsu"><div class="XiG zI7 iyn Hsu" style="width: 100%;"><div class="zI7 iyn Hsu" style="opacity: 1; transition: opacity 0.25s ease 0s;"><div class="zI7 iyn Hsu"><button aria-label="Logout" type="button" tabindex="0" style="min-height: 47px; text-align: center; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; background: rgb(17, 17, 17); padding: 14px 20px; border-radius: 8px; outline: 0px; color: white; font-weight: bold; font-size: 14px; border: none;"><div class="Umk zI7 iyn Hsu"><div class="buttonTextColor"><svg class="Hn_ gUZ erh U9O kVc" height="16" width="16" viewBox="0 0 24 24" aria-label="Logout" role="img"><path d="M7.184 22.56a1.5 1.5 0 0 0-.002-2.121l-1.442-1.44 8.76-.003a1.5 1.5 0 1 0-.001-3l-8.755.003 1.437-1.44a1.5 1.5 0 1 0-2.123-2.118L0 17.508l5.063 5.054a1.5 1.5 0 0 0 2.121-.002m9.637-10.998a1.501 1.501 0 0 1-.002-2.121L18.256 8 9.5 8.005a1.5 1.5 0 0 1-.001-3L18.26 5l-1.442-1.44a1.494 1.494 0 0 1-.441-1.061 1.498 1.498 0 0 1 2.56-1.061L24 6.493l-5.058 5.067a1.5 1.5 0 0 1-2.121.002"></path></svg></div></div>Logout</button></div></div></div></div></div>';
        var item = '<div class="C9q Shl zI7 iyn Hsu rewards_btn"><a href="/pages/rewards"><div class="FNs zI7 iyn Hsu"><div class="XiG zI7 iyn Hsu" style="width: 100%;"><div class="zI7 iyn Hsu" style="opacity: 1; transition: opacity 0.25s ease 0s;"><div class="zI7 iyn Hsu"><button aria-label="Order history" type="button" tabindex="0" style="min-height: 47px; text-align: center; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; background: rgb(17, 17, 17); padding: 14px 20px; border-radius: 8px; outline: 0px; color: white; font-weight: bold; font-size: 14px; border: none;">Rewards</button></div></div></div></a></div>';
        if (!document.querySelector('.rewards_btn')) container.appendChild(_fromHTML(item));
        if (!document.querySelector('button[aria-label="Logout"]')) container.insertBefore(_fromHTML(logoutBtn), container.firstChild);
    }
    window.setInterval(appendbtn, 500);
}
window.addEventListener('load', function () {
    if (window.location.href.indexOf('a/account/subscriptions') > -1) checkbtn();
    if (window.location.href.indexOf('a/account/orders') > -1) checkbtn();
});


// product dot height get
_ready(function () {
    var fig = document.querySelector('.membership-product-slider .product-inner .product-card-figure');
    var h = fig ? fig.offsetHeight : 0;
    document.querySelectorAll('.membership-product-list-wrapper ul.slick-dots').forEach(function (d) { d.style.top = h + 'px'; });
});

document.querySelectorAll('.main-header--nav-links .nav-item.has-mega-nav').forEach(function (item) {
    item.addEventListener('mouseenter', function () { var h = document.querySelector('header'); if (h) h.classList.add('result_hover'); });
    item.addEventListener('mouseleave', function () { var h = document.querySelector('header'); if (h) h.classList.remove('result_hover'); });
});

document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pdp_upsell_product .upsell_btn');
    if (!btn) return;
    e.preventDefault();
    var variant_id = btn.getAttribute('data-variant');
    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ quantity: 1, id: variant_id })
    }).then(function (r) { return r.json(); }).then(function () {
        if (window.cartMini) { window.cartMini.refresh(); setTimeout(function () { window.cartMini.open(); }, 100); }
    }).catch(function () {});
});

document.querySelectorAll('.sub-menu > li > a').forEach(function (a) {
  a.addEventListener('click', function (event) {
    var nxt = this.nextElementSibling;

    // This is a normal link, not a submenu trigger.
    if (!nxt || !nxt.querySelector('.sub-sub-menu')) return;

    event.preventDefault();

    var isOpen = _visible(nxt);

    // Close other submenu panels only — never close `nxt` here.
    document.querySelectorAll('.sub-menu > li > a').forEach(function (link) {
      if (link !== this) {
        link.classList.remove('active');
      }
    }, this);

    document.querySelectorAll('.sub-sub-menu_main').forEach(function (panel) {
      if (panel !== nxt) {
        _slideUp(panel);
      }
    });

    if (isOpen) {
      this.classList.remove('active');
      _slideUp(nxt);
    } else {
      this.classList.add('active');
      _slideDown(nxt);
    }
  });
});

document.querySelectorAll('.menu-accoridian .mob_menu_tabs_list .tab_link').forEach(function (link) {
    link.addEventListener('click', function () {
        var tab_id = this.getAttribute('data-tab');
        var nav = this.closest('.mobile-nav');
        if (nav) {
            nav.querySelectorAll('.menu-accoridian .mob_menu_tabs_list .tab_link').forEach(function (x) { x.classList.remove('current'); });
            nav.querySelectorAll('.menu-accoridian .menu-accoridian_tab_main .msubmenu').forEach(function (x) { x.classList.remove('current'); });
        }
        this.classList.add('current');
        var tab = document.getElementById(tab_id);
        if (tab) tab.classList.add('current');
    });
});

function handleResize() {
    if (window.innerWidth > 959) {
        document.querySelectorAll('.main-header').forEach(function (x) { x.classList.remove('opennav'); });
    }
}
window.addEventListener('resize', handleResize);
handleResize();
document.addEventListener('click', function (e) {
    if (!e.target.closest('.main-header-wrap .close-menu')) return;
    document.querySelectorAll('.main-header').forEach(function (x) { x.classList.remove('opennav'); });
});

document.addEventListener('click', function (e) {
    var btn = e.target.closest('.main-div .read-more');
    if (!btn) return;
    var mainDiv = btn.closest('.main-div');
    var desc = mainDiv ? mainDiv.querySelector('.desc_collection') : null;
    if (btn.classList.contains('active')) {
        btn.classList.remove('active');
        if (desc) { _slideUp(desc); desc.classList.remove('active'); }
    } else {
        btn.classList.add('active');
        if (desc) { _slideDown(desc); desc.classList.add('active'); }
    }
});

// Create an array to store all swiper instances
const deskPopInstances = [];

// Initialize Swiper for each .desktop_popup_slider
document.querySelectorAll('.desktop_popup_slider').forEach(function (element) {
    const swiperInstance = new Swiper(element, {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
            nextEl: '.swiper-button-next.desktop_popup_arrow',
            prevEl: '.swiper-button-prev.desktop_popup_arrow',
        },
        pagination: {
            el: ".swiper-pagination.desktop_popup_pagination",
            clickable: true,
        },
    });

    // Store instance with reference to its DOM element
    deskPopInstances.push({
        element: element,
        instance: swiperInstance
    });
});

// variant change input
document.addEventListener('change', function (e) {
    var input = e.target.closest('.pdp_pack_list .pdp_pack_input');
    if (!input) return;
    var container_v = document.querySelector('.pdp_hero_left_inner');
    var popupSlider_v = container_v ? container_v.querySelector('.desktop_popup_slider') : null;
    var match_v = deskPopInstances.find(function (item) { return item.element === popupSlider_v; });
    if (match_v) { match_v.instance.update(); }
    else { console.warn('No matching Swiper instance to update'); }

    var variant_id = input.value;
    var pack_mprice = input.getAttribute('data-price');
    var cur_varaint = (input.getAttribute('data-var') || '').toLowerCase().replace(/ /g, '-');

    var sel = document.querySelector('.product-select[name=id]');
    if (sel) sel.value = variant_id;
    if (variant_id) {
        var _vurl = new URL(window.location.href);
        _vurl.searchParams.set('variant', variant_id);
        window.history.replaceState({}, '', _vurl);
    }
    var dayLeft = document.querySelector('.pdp_day_left');
    var data_qty_limit = parseInt(dayLeft ? dayLeft.getAttribute('data-qty-limit') : '');
    var selected = sel ? sel.options[sel.selectedIndex] : null;
    var cur_qty = selected ? selected.getAttribute('data-qty') : null;
    var cur_qty_Sell = parseInt(selected ? selected.getAttribute('data-out-sell') : '');
    if (cur_qty_Sell == 1) {
        if (dayLeft) dayLeft.style.display = 'none';
    } else if (cur_qty < data_qty_limit) {
        if (dayLeft) { dayLeft.style.display = ''; var q = dayLeft.querySelector('.qty'); if (q) q.textContent = cur_qty; }
    } else {
        if (dayLeft) dayLeft.style.display = 'none';
    }

    var subLi = document.querySelector('li.pdp_drop_slide_wpr.subscribe_save');
    var subText = document.querySelector('.subscription_text');
    if (input.classList.contains('hideVariantSubscription')) {
        if (subLi) subLi.classList.add('hideVariant_ubscription');
        _clickSel('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_radio');
        if (subText) subText.textContent = 'Subscribe & Save Unavailable';
    } else {
        var per_amount = subLi ? subLi.getAttribute('data-dv-per') : '';
        if (subText) subText.textContent = 'Subscribe & Save ' + per_amount + '%';
        _clickSel('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_radio');
        if (subLi) subLi.classList.remove('hideVariant_ubscription');
        if (document.querySelector('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save:not(.hideVariant_ubscription):not(.unavailable_subscribe) .pdp_drop_radio')) {
            _clickSel('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save .pdp_drop_radio');
        } else {
            _clickSel('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_radio');
        }
    }

    variant_Desc(cur_varaint);

    var atcSpans = document.querySelectorAll('.add_to_cart_btn span');
    if (document.querySelector('.pdp_pack_option_col')) {
        document.querySelectorAll('.pdp_pack_option_col').forEach(function (col) {
            var inp = col.querySelector('input');
            var pack = parseInt(inp ? inp.value : '');
            var percentage = parseInt(inp ? inp.getAttribute('data-pv') : '');
            var mprice = pack_mprice * pack;
            var final;
            if (percentage > 0) {
                final = mprice - (mprice * parseInt(percentage) / 100);
                col.setAttribute('data-pack-dis-price', Shopify.formatMoney(final));
            }
            var sub_percentage = parseInt(subLi ? subLi.getAttribute('data-dv-per') : '');
            var sub_final = mprice - (mprice * parseInt(sub_percentage) / 100);
            col.setAttribute('data-sub-price', Shopify.formatMoney(sub_final));
            col.setAttribute('data-pack-price', Shopify.formatMoney(mprice));
            var m_price = parseFloat(Shopify.formatMoney(mprice).replace('$', ''));
            var wpr = document.querySelector('.pdp_pack_option_wpr');
            var data_t = parseFloat(wpr ? wpr.getAttribute('data-thresh') : '');
            var freeShip = col.querySelector('.pdp_pack_option_value .pack_free_shipping');
            if (freeShip) freeShip.style.display = (m_price > data_t) ? '' : 'none';
            var gummy = col.querySelector('.pdp_pack_option_value .gummies_count');
            if (gummy) {
                var gPrice = (parseFloat((final ? final : (m_price * 100)) / 100) / parseFloat(gummy.getAttribute('data-gummies'))).toFixed(2);
                gummy.textContent = '$' + gPrice + ' / Gummy';
            }
        });

        var checkedPack = document.querySelector('.pdp_pack_option_input:checked');
        var checkedCol = checkedPack ? checkedPack.closest('.pdp_pack_option_col') : null;
        var cur_pack_mprice = checkedCol ? checkedCol.getAttribute('data-pack-price') : null;
        var cur_pack_disprice = checkedCol ? checkedCol.getAttribute('data-pack-dis-price') : null;
        var data_sub_price = checkedCol ? checkedCol.getAttribute('data-sub-price') : null;
        var buyPrice = document.querySelector('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .pdp_drop_price');

        if (cur_pack_disprice) {
            if (buyPrice) buyPrice.innerHTML = '<span class="del_price">' + cur_pack_disprice + '</span><span class="price">' + cur_pack_mprice + '</span>';
            atcSpans.forEach(function (s) { s.textContent = cur_pack_mprice; });
        } else {
            if (buyPrice) buyPrice.innerHTML = '<span class="price">' + cur_pack_mprice + '</span>';
            var subMain = document.querySelector('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save .price_main');
            if (subMain) subMain.innerHTML = '<span class="del_price">' + cur_pack_mprice + '</span><span class="price">' + data_sub_price + '</span>';
            atcSpans.forEach(function (s) { s.textContent = cur_pack_mprice; });
            var oneGummy = document.querySelector('ul.pdp_drop_main li.pdp_drop_slide_wpr.buy_once .gummies_count');
            if (oneGummy) {
                var goPrice = (parseFloat(cur_pack_mprice.replace('$', '')) / parseFloat(oneGummy.getAttribute('data-gummies'))).toFixed(2);
                oneGummy.textContent = '$' + goPrice + ' / Gummy';
            }
            var ssGummy = document.querySelector('ul.pdp_drop_main li.pdp_drop_slide_wpr.subscribe_save .gummies_count');
            if (ssGummy) {
                var ssPrice = (parseFloat(data_sub_price.replace('$', '')) / parseFloat(ssGummy.getAttribute('data-gummies'))).toFixed(2);
                ssGummy.textContent = '$' + ssPrice + ' / Gummy';
            }
        }
    } else {
        atcSpans.forEach(function (s) { s.textContent = Shopify.formatMoney(pack_mprice); });
    }

    var newUrl = [window.location.protocol, '//', window.location.host, window.location.pathname, '?variant=', variant_id];
    if (Theme.utmString != '') newUrl.push('&' + Theme.utmString);
    var variantUrl = newUrl.join('');
    window.history.replaceState({ path: variantUrl }, '', variantUrl);

    var preOrder = document.querySelector('.pdp_pre_order');
    if (typeof window.metadata[variant_id] != 'undefined' && window.metadata[variant_id].pre_order_text != '') {
        var pt = document.querySelector('.pdp_pre_order .pre_order_text');
        if (pt) pt.textContent = window.metadata[variant_id].pre_order_text;
        if (preOrder) preOrder.style.display = '';
    } else {
        if (preOrder) preOrder.style.display = 'none';
    }
});

document.addEventListener('click', function (e) {
    var slide = e.target.closest('.new_desktop_slider .swiper-slide');
    if (!slide) return;
    var container = document.querySelector('.pdp_hero_left_inner');
    var popup = container ? container.querySelector('.pdp_desktop_popup') : null;
    var galleryWpr = slide.closest('.pdp_gallery_wpr');
    var popupSlider = galleryWpr ? galleryWpr.querySelector('.desktop_popup_slider') : null;
    var data_slide = parseInt(slide.getAttribute('data-slide'), 10) || 0;
    if (popup) popup.classList.add('is-open');
    document.body.classList.add('is-open');
    var match = deskPopInstances.find(function (item) { return item.element === popupSlider; });
    if (match) match.instance.slideTo(data_slide > 0 ? data_slide - 1 : data_slide);
});

function imginset() {
    var arrows = document.querySelectorAll('.template--page-ways-to-save .membership-product-list-wrapper .slick-arrow');
    if (window.innerWidth > 768) {
        var fig = document.querySelector('.template--page-ways-to-save.product-grid-square .product-card-figure');
        var headerHeight = fig ? fig.offsetHeight : 0;
        arrows.forEach(function (a) { a.style.top = (headerHeight / 2) + 'px'; });
    } else {
        arrows.forEach(function (a) { a.style.top = ''; });
    }
}
imginset();
window.addEventListener('load', imginset);
window.addEventListener('resize', imginset);
window.addEventListener('orientationchange', imginset);

document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.desk_close_icon, .desk_overlay_popup');
    if (!trigger) return;
    var wrap = trigger.closest('.pdp_hero_left_inner');
    var popup = wrap ? wrap.querySelector('.pdp_desktop_popup') : null;
    if (popup) popup.classList.remove('is-open');
    document.body.classList.remove('is-open');
});